import { blendedServices, SummaryMetricsDictionary } from './';
import { FeatureFlag } from '@tw/feature-flag-system/module/types';

export const SummaryMetrics: SummaryMetricsDictionary = {
  sales: {
    id: 'sales',
    title: 'Order Revenue',
    chart: 'chartSales',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalSales',
    providerId: 'shopify',
    metric: 'sales',
    tip: 'Order Revenue = Gross Sales - Discounts + Taxes + Shipping',
    services: ['shopify'],
    icon: 'shopify',
  },
  newCustomerSales: {
    id: 'newCustomerSales',
    title: 'New Customer Revenue',
    chart: 'chartNewCustomerSales',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'newCustomerSales',
    tip: 'Amount of sales derived from new customers',
    services: ['shopify'],
    icon: 'shopify',
    providerId: 'shopify',
    metric: 'newCustomerSales',
  },
  netSales: {
    id: 'netSales',
    title: 'Total Sales',
    chart: 'netSalesChart',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'netSales',
    tip: 'Gross Sales - Discounts - Returns + Shipping + Tax',
    services: ['shopify'],
    icon: 'shopify',
    providerId: 'shopify',
    metric: 'netSales',
  },
  rcRevenue: {
    id: 'rcRevenue',
    title: 'Returning Customer Revenue',
    chart: 'chartReturningCustomerSales',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'rcRevenue',
    tip: 'Amount of sales derived from returning customers',
    services: ['shopify'],
    icon: 'shopify',
    providerId: 'shopify',
    metric: 'rcRevenue',
  },
  paymentGateways: {
    id: 'paymentGateways',
    title: 'Payment Gateways',
    color: '#737D3F',
    type: 'currency',
    valueToFixed: 0,
    features: [FeatureFlag.EXPENSES_ACCESS_FF],
    metricId: 'totalPaymentGatewayCosts',
    tip: 'Payment processing fees. Edit these in: Store > Gateway Costs',
    chart: 'totalPaymentGatewayCostsChart',
    services: ['shopify'],
    icon: 'tripleWhale',
    providerId: 'shopify',
    metric: 'paymentGateways',
  },
  cogsOrders: {
    id: 'cogsOrders',
    title: 'COGS Orders',
    color: '#007D3F',
    type: 'currency',
    features: [FeatureFlag.EXPENSES_ACCESS_FF],
    valueToFixed: 0,
    metricId: 'totalProductCostsOrders',
    tip: 'Cost of goods sold. Imported from Shopify, or edit these in: Store > Cost of Goods',
    icon: 'shopify',
    services: ['shopify'],
    providerId: 'shopify',
    metric: 'cogsOrders',
  },
  cogsRefunds: {
    id: 'cogsRefunds',
    title: 'COGS Refunds',
    color: '#007D3F',
    type: 'currency',
    features: [FeatureFlag.EXPENSES_ACCESS_FF],
    valueToFixed: 0,
    metricId: 'totalCostsRefunds',
    tip: 'Cost of goods refunded. Imported from Shopify, or edit these in: Store > Cost of Goods',
    icon: 'shopify',
    services: ['shopify'],
    providerId: 'shopify',
    metric: 'cogsRefunds',
  },
  cogs: {
    id: 'cogs',
    title: 'COGS',
    color: '#007D3F',
    type: 'currency',
    features: [FeatureFlag.EXPENSES_ACCESS_FF],
    chart: 'chartCogs',
    valueToFixed: 0,
    metricId: 'totalProductCosts',
    tip: 'Cost of goods sold in this time frame, minus cost of goods of refunded items in this time frame. Imported from Shopify, or edit these in: Store > Cost of Goods.',
    icon: 'shopify',
    services: ['shopify'],
    providerId: 'shopify',
    relatedMetrics: ['cogsOrders', 'cogsRefunds'],
    metric: 'cogs',
  },
  handlingFees: {
    id: 'handlingFees',
    title: 'Handling Fees',
    color: '#f49099',
    valueToFixed: 0,
    features: [FeatureFlag.EXPENSES_ACCESS_FF],
    type: 'currency',
    chart: 'chartHandlingFees',
    metricId: 'totalHandlingFees',
    tip: 'Cost of boxing, packaging, or “pick & pack” services. Edit these in: Store > Cost of Goods',
    icon: 'shopify',
    services: ['shopify'],
    providerId: 'shopify',
    metric: 'handlingFees',
  },
  customSpends: {
    id: 'customSpends',
    title: 'Custom Expenses',
    color: '#309811',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalCustomSpends',
    tip: 'Any additional expenses you’d like to see deducted from your Net Profit. Includes custom expenses marked as ad spend. Edit these in Store > Custom Expenses.',
    icon: 'tripleWhale',
    services: ['shopify'],
    metricPopupWidget: true,
    chart: 'totalCustomSpendsChart',
    providerId: 'triple-whale',
    // metric: 'customSpends',
  },
  inventoryItems: {
    id: 'inventoryItems',
    title: 'Items',
    color: '#369a36',
    metricId: 'totalInventoryItems',
    tip: 'Number of total items you have in stock',
    services: ['shopify'],
    icon: 'shopify',
    type: 'decimal',
    providerId: 'shopify',
    metric: 'inventoryItems',
  },
  inventoryItemsMissing: {
    id: 'inventoryItemsMissing',
    title: 'Missing Items',
    color: '#b7b78c',
    metricId: 'totalInventoryItemsMissing',
    tip: 'Number of back order items',
    services: ['shopify'],
    icon: 'shopify',
    type: 'decimal',
    providerId: 'shopify',
    metric: 'inventoryItemsMissing',
  },
  totalInventoryCost: {
    id: 'totalInventoryCost',
    title: 'Cost',
    color: '#0567ad',
    type: 'currency',
    valueToFixed: 0,
    metricId: 'totalInventoryCost',
    tip: 'How much did the items cost',
    services: ['shopify'],
    icon: 'shopify',
    providerId: 'shopify',
    metric: 'inventoryCost',
  },
  totalInventoryValue: {
    id: 'totalInventoryValue',
    title: 'Value',
    color: '#461d4e',
    type: 'currency',
    valueToFixed: 0,
    metricId: 'totalInventoryValue',
    tip: 'Retail value of items in stock',
    services: ['shopify'],
    icon: 'shopify',
    providerId: 'shopify',
    metric: 'inventoryValue',
  },
  shopifyAov: {
    id: 'shopifyAov',
    title: 'True AOV',
    chart: 'chartShopifyAov',
    color: '#197DF0',
    shortTitle: 'True AOV',
    valueToFixed: 0,
    metricId: 'shopifyAov',
    type: 'currency',
    tip: 'Equates to Total Sales (excluding taxes, duties, and shipping) / Number of orders, excluding zero value orders',
    services: ['shopify'],
    icon: 'shopify',
    providerId: 'shopify',
    metric: 'aov',
  },
  shopifyAovIncludeZero: {
    id: 'shopifyAovIncludeZero',
    title: 'Average Order Value',
    chart: 'chartShopifyAovIncludeZero',
    color: '#197DF0',
    shortTitle: 'Average Order Value',
    valueToFixed: 0,
    metricId: 'shopifyAovIncludeZero',
    type: 'currency',
    tip: 'Equates to Total Sales (excluding taxes, duties, and shipping)  / Number of orders. This is directly from Shopify',
    services: ['shopify'],
    icon: 'shopify',
    providerId: 'shopify',
    metric: 'aov',
  },
  aov: {
    id: 'aov',
    title: 'AOV',
    chart: 'chartGaRevenuePerTransaction',
    color: '#FF8456',
    valueToFixed: 2,
    type: 'currency',
    metricId: 'averageGaRevenuePerTransaction',
    isShow: (state) => state.isShowGoogleAnalytics,
    tip: 'Average Order Value',
    services: ['GOOGLE_ANALYTICS'],
    icon: 'tripleWhale',
  },
  facebookAds: {
    id: 'facebookAds',
    title: 'Facebook Ads',
    reportTitle: 'Facebook Ads Spend',
    chart: 'chartFacebookInsights',
    color: '#F0C808',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'fb_ads_spend',
    services: ['facebook-ads'],
    tip: 'Ad spend',
    icon: 'facebook',
    providerId: 'facebook-ads',
    metric: 'spend',
  },
  googleAds: {
    id: 'googleAds',
    title: 'Google Ads',
    reportTitle: 'Google Ads Spend',
    chart: 'chartGoogleAds',
    color: '#242423',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'ga_adCost',
    services: ['google-ads'],
    tip: 'Google Ad Spend',
    icon: 'googleAds',
    providerId: 'google-ads',
    metric: 'spend',
  },
  googleAllCpa: {
    id: 'googleAllCpa', // There was a reverse between googleCpa/googleAllCpa. Its too complex to fix since it requires reimport for all the shops so I just reverse here.
    title: 'Google CPA',
    shortTitle: 'CPA',
    color: '#af24293',
    type: 'currency',
    metricId: 'googleAllCpa',
    services: ['google-ads'],
    valueToFixed: 2,
    tip: 'Cost Per Acquisition',
    positiveComparison: -1,
    icon: 'googleAds',
    chart: 'googleAllCpaChart',
    providerId: 'google-ads',
    metric: 'cpa',
  },
  googleBounceRate: {
    id: 'googleBounceRate',
    title: 'Bounce Rate',
    color: '#f09317',
    isShow: (state) => state.isShowGoogleAnalytics,
    valueToFixed: 0,
    type: 'percent',
    metricId: 'googleBounceRate',
    services: ['GOOGLE_ANALYTICS'],
    tip: 'Percentage of visitors to the website that leave before any action or visiting other pages',
    icon: 'googleAnalytics',
  },
  googleConversionValue: {
    id: 'googleConversionValue',
    title: 'Google Conversion Value',
    shortTitle: 'Conversion Value',
    chart: 'googleConversionValueChart',
    color: '#ed6788',
    valueToFixed: 0,
    metricId: 'googleConversionValue',
    services: ['google-ads'],
    type: 'currency',
    tip: 'Recorded revenue from Google Ads',
    icon: 'googleAds',
    providerId: 'google-ads',
    metric: 'conversionValue',
  },
  snapchatAds: {
    id: 'snapchatAds',
    title: 'Snapchat Ads',
    reportTitle: 'Snapchat Ads Spend',
    chart: 'chartSnapchatAds',
    color: '#9999ff',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalSnapchatSpend',
    services: ['snapchat-ads'],
    tip: 'Snapchat Ad Spend',
    icon: 'snapchat',
    providerId: 'snapchat-ads',
    metric: 'spend',
  },
  snapchatRoas: {
    id: 'snapchatRoas',
    title: 'Snapchat ROAS',
    shortTitle: 'ROAS',
    chart: 'snapchatRoasChart',
    color: '#3333ff',
    type: 'decimal',
    valueToFixed: 2,
    metricId: 'totalSnapchatRoas',
    services: ['snapchat-ads'],
    tip: 'Return on Ad Spend',
    icon: 'snapchat',
    providerId: 'snapchat-ads',
    metric: 'roas',
    isSupportCumulative: false,
  },
  snapchatImpressions: {
    id: 'snapchatImpressions',
    title: 'Snapchat Impressions',
    shortTitle: 'Impressions',
    color: '#1369af',
    type: 'decimal',
    metricId: 'snapchatImpressions',
    chart: 'snapchat_impressions_chart',
    services: ['snapchat-ads'],
    icon: 'snapchat',
    providerId: 'snapchat-ads',
    metric: 'impressions',
  },
  snapchatSwipes: {
    id: 'snapchatSwipes',
    title: 'Snapchat Swipes',
    shortTitle: 'Swipes',
    color: '#af6913',
    metricId: 'snapchat_swipes',
    chart: 'snapchat_swipes_chart',
    type: 'decimal',
    services: ['snapchat-ads'],
    icon: 'snapchat',
    providerId: 'snapchat-ads',
    // metric: 'swipes',
  },
  snapchatCpm: {
    id: 'snapchatCpm',
    title: 'Snapchat CPM',
    shortTitle: 'CPM',
    color: '#69af13',
    type: 'currency',
    valueToFixed: 0,
    metricId: 'snapchatCpm',
    chart: 'snapchatCpmChart',
    services: ['snapchat-ads'],
    positiveComparison: -1,
    tip: 'Cost Per 1000 Impressions',
    icon: 'snapchat',
    providerId: 'snapchat-ads',
    metric: 'cpm',
  },
  snapchatCpa: {
    id: 'snapchatCpa',
    title: 'Snapchat CPA',
    shortTitle: 'CPA',
    color: '#01e78f',
    type: 'currency',
    valueToFixed: 1,
    metricId: 'snapchatCpa',
    chart: 'snapchatCpaChart',
    services: ['snapchat-ads'],
    positiveComparison: -1,
    tip: 'Cost Per Acquisition',
    icon: 'snapchat',
    providerId: 'snapchat-ads',
    metric: 'cpa',
  },
  snapchatConversionValue: {
    id: 'snapchatConversionValue',
    title: 'Snapchat Conversion Value',
    shortTitle: 'Conversion Value',
    color: '#87bddb',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalSnapchatConversionPurchasesValue',
    chart: 'chartSnapchatConversionPurchasesValue',
    services: ['snapchat-ads'],
    icon: 'snapchat',
    providerId: 'snapchat-ads',
    metric: 'conversionValue',
  },
  snapchatConversionPurchases: {
    id: 'snapchatConversionPurchases',
    title: 'Snapchat Conversion Purchases',
    shortTitle: 'Purchases',
    color: '#87bddb',
    type: 'decimal',
    metricId: 'totalSnapchatConversionPurchases',
    chart: 'chartSnapchatConversionPurchases',
    services: ['snapchat-ads'],
    icon: 'snapchat',
    providerId: 'snapchat-ads',
    metric: 'purchases',
  },
  googleConversionRate: {
    id: 'googleConversionRate',
    title: 'Conversion Rate',
    chart: 'chartGaTransactionsPerSession',
    color: '#6C756B',
    type: 'percent',
    isShow: (state) => state.isShowGoogleAnalytics,
    valueToFixed: 2,
    metricId: 'averageGaTransactionsPerSession',
    tip: 'Google Analytics reported conversion rate',
    services: ['GOOGLE_ANALYTICS'],
    icon: 'googleAnalytics',
  },
  googleSessions: {
    id: 'googleSessions',
    title: 'Sessions',
    type: 'decimal',
    chart: 'chartGaUsers',
    color: '#89043D',
    isShow: (state) => state.isShowGoogleAnalytics,
    metricId: 'totalGoogleAnalyticsSessions',
    services: ['GOOGLE_ANALYTICS'],
    icon: 'googleAnalytics',
  },
  shopifyOrders: {
    id: 'shopifyOrders',
    title: 'Shopify Orders',
    chart: 'chartOrders',
    color: '#99ff99',
    type: 'decimal',
    metricId: 'totalOrders',
    services: ['shopify'],
    icon: 'shopify',
    providerId: 'shopify',
    metric: 'orders',
  },
  totalNetProfit: {
    id: 'totalNetProfit',
    title: 'Net Profit',
    chart: 'totalNetProfitChart',
    hasBackgroundByDefault: true,
    type: 'currency',
    color: '#9999ff',
    metricId: 'totalNetProfit',
    features: [FeatureFlag.EXPENSES_ACCESS_FF],
    valueToFixed: 0,
    relatedMetrics: [
      'sales',
      'shipping',
      'paymentGateways',
      'handlingFees',
      'customSpends',
      'cogs',
      'totalRefunds',
      'facebookAds',
      'googleAds',
      'snapchatAds',
      'tiktokAds',
      'pinterestAds',
      'influencerSpend',
      'twitterAds',
      'taxes',
      'amazonNetProfit',
      'bingAdSpend',
      'mountainSpend',
      'criteoSpend',
    ],
    tip: 'Order Revenue - Returns - Expenses (COGS, Shipping, Handling, Payment Gateways, Taxes, Custom Expenses) - Blended Ad Spend',
    services: ['triple-whale'],
    icon: 'tripleWhale',
    additionalMarketplaceBadge: true,
    providerId: 'triple-whale',
    metric: 'netProfit',
    dependOnCostSettings: true,
  },
  cashTurnover: {
    id: 'cashTurnover',
    title: 'Cash Turnover',
    type: 'currency',
    color: '#0911f3',
    metricId: 'cashTurnover',
    valueToFixed: 0,
    tip: 'Order Revenue - Shipping - Taxes - Blended Ad Spend - Returns',
    services: ['triple-whale'],
    icon: 'tripleWhale',
    providerId: 'triple-whale',
    metric: 'cashTurnover',
    dependOnCostSettings: true,
  },
  totalNetMargin: {
    id: 'totalNetMargin',
    title: 'Net Margin',
    type: 'percent',
    color: '#72a220',
    metricId: 'totalNetMargin',
    valueToFixed: 0,
    tip: 'Net Profit / Order Revenue x 100. In other words: Percentage of Sales that is Net Profit. Answers the question of: “What percentage of my [Sales] is my [Net Profit]?”',
    services: ['triple-whale'],
    icon: 'tripleWhale',
    additionalMarketplaceBadge: true,
    providerId: 'triple-whale',
    metric: 'netProfitMargin', //??
    dependOnCostSettings: true,
  },
  totalCpa: {
    id: 'totalCpa',
    title: 'Blended CPA',
    shortTitle: 'CPA',
    chart: 'chartTotalCpa',
    hasTarget: true,
    color: '#339999',
    metricId: 'totalCpa',
    valueToFixed: 1,
    type: 'currency',
    services: blendedServices,
    tip: 'Cost Per Acquisition. Ad Spend/Google Analytics Transaction',
    positiveComparison: -1,
    icon: 'blended',
    isShow: () => false, //if you want to use this metric, you need to change this to true or remove this line
    providerId: 'triple-whale',
    metric: 'blendedCpa', //??
  },
  googleRps: {
    id: 'googleRps',
    title: 'RPS',
    hasTarget: true,
    color: '#333399',
    type: 'currency',
    valueToFixed: 1,
    metricId: 'totalRevenuePerSession',
    tip: 'Revenue Per Session. Sales / Web Sessions',
    services: ['shopify'],
    icon: 'googleAnalytics',
    chart: 'totalRevenuePerSessionChart',
  },
  totalRefunds: {
    id: 'totalRefunds',
    title: 'Returns',
    chart: 'chartRefunds',
    color: '#993399',
    type: 'currency',
    metricId: 'totalRefunds',
    valueToFixed: 0,
    positiveComparison: -1,
    tip: 'The Amount Of Order Revenue Returned To A Customer Over A Period Of Time',
    services: ['shopify'],
    icon: 'shopify',
    providerId: 'shopify',
    metric: 'refunds',
  },
  facebookRoas: {
    id: 'facebookRoas',
    title: 'Facebook ROAS',
    shortTitle: 'ROAS',
    type: 'decimal',
    chart: 'chartFacebookPurchaseRoas',
    valueToFixed: 2,
    color: '#9933ff',
    metricId: 'fb_ads_purchase_roas',
    services: ['facebook-ads'],
    tip: 'Return on Ad Spend',
    icon: 'facebook',
    providerId: 'facebook-ads',
    metric: 'roas',
    isSupportCumulative: false,
  },
  googleRoas: {
    id: 'googleRoas',
    title: 'Google ROAS',
    shortTitle: 'ROAS',
    type: 'decimal',
    valueToFixed: 2,
    color: '#aaffdd',
    metricId: 'ga_ROAS',
    chart: 'googleAdsRoasChart',
    services: ['google-ads'],
    tip: 'Return on Ad Spend',
    icon: 'googleAds',
    providerId: 'google-ads',
    metric: 'roas',
    isSupportCumulative: false,
  },
  totalGoogleAdsCtr: {
    id: 'totalGoogleAdsCtr',
    title: 'Google CTR',
    shortTitle: 'CTR',
    valueToFixed: 2,
    color: '#aaffdd',
    type: 'decimal',
    metricId: 'totalGoogleAdsCtr',
    services: ['google-ads'],
    tip: 'Click Through Rate. Percentage of people clicking the ad',
    icon: 'googleAds',
    chart: 'totalGoogleAdsCtrChart',
    providerId: 'google-ads',
    metric: 'ctr',
  },
  totalGoogleAdsCpm: {
    id: 'totalGoogleAdsCpm',
    title: 'Google CPM',
    shortTitle: 'CPM',
    type: 'decimal',
    valueToFixed: 2,
    color: '#aaffdd',
    metricId: 'totalGoogleAdsCpm',
    services: ['google-ads'],
    tip: 'Cost Per 1000 Impressions',
    icon: 'googleAds',
    chart: 'totalGoogleAdsCpmChart',
    providerId: 'google-ads',
    metric: 'cpm',
  },
  googleCpc: {
    id: 'googleCpc',
    title: 'Google CPC',
    shortTitle: 'CPC',
    valueToFixed: 2,
    type: 'decimal',
    color: '#aaffdd',
    metricId: 'googleCpc',
    services: ['google-ads'],
    tip: 'Cost Per Click',
    icon: 'googleAds',
    providerId: 'google-ads',
    metric: 'cpc',
  },
  totalGoogleAdsClicks: {
    id: 'totalGoogleAdsClicks',
    title: 'Google Clicks',
    shortTitle: 'Clicks',
    type: 'decimal',
    color: '#aaffdd',
    metricId: 'totalGoogleAdsClicks',
    services: ['google-ads'],
    icon: 'googleAds',
    chart: 'googleAdsClicksChart',
    providerId: 'google-ads',
    metric: 'clicks',
  },
  totalGoogleAdsImpressions: {
    id: 'totalGoogleAdsImpressions',
    title: 'Google Impressions',
    type: 'decimal',
    shortTitle: 'Impressions',
    color: '#aaffdd',
    metricId: 'totalGoogleAdsImpressions',
    services: ['google-ads'],
    icon: 'googleAds',
    chart: 'totalGoogleAdsImpressionsChart',
    providerId: 'google-ads',
    metric: 'impressions',
  },
  ga_transactions_adGroup: {
    id: 'ga_transactions_adGroup',
    title: 'Google All Conversions',
    type: 'decimal',
    shortTitle: 'All Conversions',
    color: '#aaffdd',
    metricId: 'ga_transactions_adGroup',
    services: ['google-ads'],
    icon: 'googleAds',
    chart: 'googleAdsAllConversionsChart',
    providerId: 'google-ads',
    metric: 'allConversions',
  },

  ga_all_transactionsRevenue_adGroup: {
    id: 'ga_all_transactionsRevenue_adGroup',
    title: 'Google All Conversions Value',
    shortTitle: 'All Conversions Value',
    type: 'decimal',
    color: '#aaffdd',
    metricId: 'ga_all_transactionsRevenue_adGroup',
    services: ['google-ads'],
    icon: 'googleAds',
    chart: 'googleAllConversionValueChart',
    providerId: 'google-ads',
    metric: 'allConversionValue',
  },
  ga_all_transactions_adGroup: {
    id: 'ga_all_transactions_adGroup',
    title: 'Google Conversions',
    type: 'decimal',
    shortTitle: 'Conversions',
    color: '#aaffdd',
    metricId: 'ga_all_transactions_adGroup',
    services: ['google-ads'],
    icon: 'googleAds',
    chart: 'googleAdsConversionsChart',
    providerId: 'google-ads',
    // metric: 'conversions',
  },
  totalAllRoas: {
    id: 'totalAllRoas',
    title: 'Google All Roas',
    shortTitle: 'All Roas',
    type: 'decimal',
    valueToFixed: 2,
    color: '#aaffdd',
    metricId: 'totalAllRoas',
    services: ['google-ads'],
    icon: 'googleAds',
    chart: 'totalAllRoasChart',
    providerId: 'google-ads',
    metric: 'roas',
    isSupportCumulative: false,
  },
  googleCpa: {
    id: 'googleCpa', // There was a reverse between googleCpa/googleAllCpa. Its too complex to fix since it requires reimport for all the shops so I just reverse here.
    title: 'Google All CPA',
    shortTitle: 'All CPA',
    color: '#af24293',
    valueToFixed: 2,
    type: 'currency',
    metricId: 'googleCpa',
    services: ['google-ads'],
    tip: 'Cost Per All Conversions',
    positiveComparison: -1,
    icon: 'googleAds',
    chart: 'googleCpaChart',
    providerId: 'google-ads',
    metric: 'cpa',
  },
  facebookCpc: {
    id: 'facebookCpc',
    title: 'Facebook CPC',
    shortTitle: 'CPC',
    color: '#a36993',
    metricId: 'averageFacebookCpc',
    chart: 'chartFacebookCpc',
    type: 'currency',
    valueToFixed: 2,
    tip: 'Cost Per Click',
    services: ['facebook-ads'],
    positiveComparison: -1,
    icon: 'facebook',
    providerId: 'facebook-ads',
    metric: 'cpc',
  },
  facebookViewThrough: {
    id: 'facebookViewThrough',
    title: 'Facebook View Conversion Value',
    shortTitle: 'VCV',
    color: '#80a369',
    metricId: 'facebookViewThrough',
    chart: 'facebookViewThroughChart',
    type: 'currency',
    valueToFixed: 0,
    isShow: (stats) => stats.isViewThrough,
    tip: 'Facebook View Conversion Value',
    services: ['facebook-ads'],
    positiveComparison: -1,
    icon: 'facebook',
    providerId: 'facebook-ads',
    // metric: 'viewThroughConversionValue',
  },
  facebookViewThroughRoas: {
    id: 'facebookViewThroughRoas',
    title: 'Facebook View ROAS',
    shortTitle: 'VROAS',
    color: '#80a369',
    metricId: 'facebookViewThroughRoas',
    chart: 'facebookViewThroughRoasChart',
    type: 'decimal',
    valueToFixed: 2,
    isShow: (stats) => stats.isViewThrough,
    tip: 'Facebook View Return on Ad Spend',
    services: ['facebook-ads'],
    positiveComparison: -1,
    icon: 'facebook',
    providerId: 'facebook-ads',
    // metric: 'viewThroughRoas',
  },
  facebookViewThroughCpa: {
    id: 'facebookViewThroughCpa',
    title: 'Facebook View CPA',
    shortTitle: 'VCPA',
    color: '#80a369',
    metricId: 'facebookViewThroughCpa',
    chart: 'facebookViewThroughCpaChart',
    type: 'decimal',
    valueToFixed: 2,
    isShow: (stats) => stats.isViewThrough,
    tip: 'Facebook View Cost Per Acquisition',
    services: ['facebook-ads'],
    positiveComparison: -1,
    icon: 'facebook',
    providerId: 'facebook-ads',
    // metric: 'viewThroughCpa',
  },
  facebookCpm: {
    id: 'facebookCpm',
    title: 'Facebook CPM',
    shortTitle: 'CPM',
    color: '#333963',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'averageFacebookCpm',
    chart: 'chartFacebookCpm',
    tip: 'Cost Per 1000 Impressions',
    services: ['facebook-ads'],
    positiveComparison: -1,
    icon: 'facebook',
    providerId: 'facebook-ads',
    metric: 'cpm',
  },
  facebookCtr: {
    id: 'facebookCtr',
    title: 'Facebook CTR',
    shortTitle: 'CTR',
    chart: 'chartFacebookCtr',
    color: '#579af2',
    valueToFixed: 2,
    type: 'percent',
    metricId: 'facebookCtr',
    tip: 'Click Through Rate. Percentage of people clicking the ad',
    services: ['facebook-ads'],
    icon: 'facebook',
    providerId: 'facebook-ads',
    metric: 'ctr',
  },
  facebookCpoc: {
    id: 'facebookCpoc',
    title: 'Facebook CPOC',
    shortTitle: 'CPOC',
    chart: 'chartFacebookCostPerOutboundClick',
    color: '#71923f',
    valueToFixed: 2,
    type: 'currency',
    metricId: 'facebookCostPerOutboundClick',
    tip: 'Cost Per Outbound Click',
    services: ['facebook-ads'],
    positiveComparison: -1,
    icon: 'facebook',
    providerId: 'facebook-ads',
    // metric: 'cpoc',
  },
  facebookConversionValue: {
    id: 'facebookConversionValue',
    title: 'Facebook Conversion Value',
    shortTitle: 'Conversion Value',
    color: '#71923f',
    metricId: 'facebookConversionValue',
    chart: 'facebookConversionValueChart',
    valueToFixed: 0,
    type: 'currency',
    tip: 'Facebook-reported revenue from Purchases on your site or on Meta Shop',
    services: ['facebook-ads'],
    icon: 'facebook',
    providerId: 'facebook-ads',
    metric: 'conversionValue',
  },
  facebookWebConversionValue: {
    id: 'facebookWebConversionValue',
    title: 'Facebook Web Conversion Value',
    shortTitle: 'Web Conversion Value',
    color: '#71923f',
    metricId: 'facebookWebConversionValue',
    chart: 'facebookWebConversionValueChart',
    valueToFixed: 0,
    type: 'currency',
    tip: 'Facebook-reported revenue from Purchases on your site',
    services: ['facebook-ads'],
    icon: 'facebook',
    providerId: 'facebook-ads',
    // metric: 'webConversionValue',
  },
  facebookMetaConversionValue: {
    id: 'facebookMetaConversionValue',
    title: 'Facebook Meta Conversion Value',
    shortTitle: 'Meta Conversion Value',
    color: '#71923f',
    metricId: 'facebookMetaConversionValue',
    chart: 'facebookMetaConversionValueChart',
    valueToFixed: 0,
    type: 'currency',
    tip: 'Facebook-reported revenue from Purchases on Meta Shop',
    services: ['facebook-ads'],
    icon: 'facebook',
    providerId: 'facebook-ads',
    metric: 'metaConversionValue',
  },
  facebookRevenuePerClick: {
    id: 'facebookRevenuePerClick',
    title: 'Revenue Per Link Click',
    color: '#2a9001',
    type: 'currency',
    valueToFixed: 2,
    metricId: 'facebookRevenuePerClick',
    chart: 'facebookRevenuePerClickChart',
    tip: 'Conversion Value / Outbound Clicks',
    services: ['facebook-ads'],
    icon: 'facebook',
    providerId: 'facebook-ads',
    // metric: 'revenuePerClick',
  },
  facebookCpa: {
    id: 'facebookCpa',
    title: 'Facebook CPA',
    shortTitle: 'CPA',
    color: '#a5c1db',
    type: 'currency',
    valueToFixed: 2,
    chart: 'facebookCpaChart',
    metricId: 'facebookCpa',
    tip: 'Cost Per Acquisition',
    services: ['facebook-ads'],
    positiveComparison: -1,
    icon: 'facebook',
    providerId: 'facebook-ads',
    metric: 'cpa',
  },
  facebookPurchases: {
    id: 'facebookPurchases',
    title: 'Purchases',
    color: '#ac26c2',
    valueToFixed: 0,
    type: 'decimal',
    chart: 'facebookPurchasesChart',
    metricId: 'facebookPurchases',
    tip: 'Orders made on your site or on Meta Shop',
    services: ['facebook-ads'],
    icon: 'facebook',
    providerId: 'facebook-ads',
    metric: 'purchases',
  },
  facebookMetaPurchases: {
    id: 'facebookMetaPurchases',
    title: 'Meta Purchases',
    color: '#ac26c2',
    valueToFixed: 0,
    type: 'decimal',
    chart: 'facebookMetaPurchasesChart',
    metricId: 'facebookMetaPurchases',
    services: ['facebook-ads'],
    tip: 'Orders made on Meta Shop',
    icon: 'facebook',
    providerId: 'facebook-ads',
    metric: 'metaPurchases',
  },
  facebookWebPurchases: {
    id: 'facebookWebPurchases',
    title: 'Web Purchases',
    color: '#ac26c2',
    valueToFixed: 0,
    type: 'decimal',
    chart: 'facebookWebPurchasesChart',
    metricId: 'facebookWebPurchases',
    tip: 'Orders made on your site',
    services: ['facebook-ads'],
    icon: 'facebook',
    providerId: 'facebook-ads',
    // metric: 'webPurchases',
  },
  newCustomersCpa: {
    id: 'newCustomersCpa',
    title: 'New Customers CPA',
    shortTitle: 'NCPA',
    chart: 'chartNewCustomersCpa',
    hasTarget: true,
    color: '#909063',
    valueToFixed: 1,
    type: 'currency',
    metricId: 'newCustomersCpa',
    positiveComparison: -1,
    tip: 'New Customer Cost Per Acquisition. Total Ad Spend / New Customers',
    icon: 'blended',
    services: ['blended'],
    isShowLoadWhenImport: 'shopify',
    providerId: 'triple-whale',
    metric: 'blendedNcCpa',
  },
  klaviyoSalesPercent: {
    id: 'klaviyoSalesPercent',
    title: 'Klaviyo Sales %',
    shortTitle: 'Klaviyo Sales',
    chart: 'chartKlaviyoPlacedOrderSalesPercent',
    color: '#a63099',
    metricId: 'totalKlaviyoPlacedOrderSalesPercent',
    type: 'percent',
    valueToFixed: 0,
    services: ['klaviyo'],
    icon: 'klaviyo',
    providerId: 'klaviyo',
    // metric: 'salesPercent',
  },
  klaviyoFlowsSalesPercent: {
    id: 'klaviyoFlowsSalesPercent',
    title: 'Klaviyo Flows Sales %',
    shortTitle: 'Klaviyo Flows Sales',
    chart: 'chartKlaviyoPlacedOrderSalesPercentFlows',
    color: '#30a699',
    metricId: 'totalKlaviyoPlacedOrderSalesPercentFlows',
    type: 'percent',
    valueToFixed: 0,
    services: ['klaviyo'],
    icon: 'klaviyo',
    providerId: 'klaviyo',
    // metric: 'flowsSalesPercent',
  },
  klaviyoCampaignsSalesPercent: {
    id: 'klaviyoCampaignsSalesPercent',
    title: 'Klaviyo Campaigns Sales %',
    shortTitle: 'Klaviyo Campaigns Sales',
    chart: 'chartKlaviyoPlacedOrderSalesPercentCampaigns',
    color: '#3099a6',
    metricId: 'totalKlaviyoPlacedOrderSalesPercentCampaigns',
    type: 'percent',
    valueToFixed: 0,
    services: ['klaviyo'],
    icon: 'klaviyo',
    providerId: 'klaviyo',
    // metric: 'campaignsSalesPercent',
  },
  klaviyoEmailOpenRate: {
    id: 'klaviyoEmailOpenRate',
    title: 'Email Open Rate',
    color: '#9399a6',
    metricId: 'klaviyoEmailOpenRate',
    type: 'percent',
    valueToFixed: 0,
    tip: "Received Emails / Opened Emails. On a one day view this metric is off and in general TripleWhale's number does not match Klaviyo's number.",
    services: ['klaviyo'],
    icon: 'klaviyo',
    providerId: 'klaviyo',
    // metric: 'emailOpenRate',
  },
  klaviyoUnsubscribed: {
    id: 'klaviyoUnsubscribed',
    title: 'Unsubscribed',
    color: '#e2e572',
    type: 'decimal',
    chart: 'chartKlaviyoUnsubscribed',
    metricId: 'totalKlaviyoUnsubscribed',
    services: ['klaviyo'],
    positiveComparison: -1,
    icon: 'klaviyo',
    providerId: 'klaviyo',
    // metric: 'unsubscribed',
  },
  klaviyoPlacedOrderTotalPriceFlows: {
    id: 'klaviyoPlacedOrderTotalPriceFlows',
    title: 'Revenue Flows',
    color: '#79ba51',
    chart: 'chartKlaviyoPlacedOrderTotalPriceFlows',
    metricId: 'totalKlaviyoPlacedOrderTotalPriceFlows',
    type: 'currency',
    valueToFixed: 0,
    services: ['klaviyo'],
    icon: 'klaviyo',
    metricPopupWidget: true,
    providerId: 'klaviyo',
    // metric: 'totalPriceFlows',
  },
  klaviyoPlacedOrderTotalPriceFlowsPercent: {
    id: 'klaviyoPlacedOrderTotalPriceFlowsPercent',
    title: 'Percent of Revenue Flows',
    color: '#071096',
    type: 'percent',
    valueToFixed: 0,
    chart: 'chartKlaviyoPlacedOrderTotalPriceFlows',
    metricId: 'totalKlaviyoPlacedOrderSalesPercentFlows',
    services: ['klaviyo'],
    icon: 'klaviyo',
    providerId: 'klaviyo',
    // metric: 'totalPriceFlowsPercent',
  },
  klaviyoPlacedOrderTotalPriceCampaigns: {
    id: 'klaviyoPlacedOrderTotalPriceCampaigns',
    title: 'Revenue Campaigns',
    color: '#1120f2',
    type: 'currency',
    valueToFixed: 0,
    chart: 'chartKlaviyoPlacedOrderTotalPriceCampaigns',
    metricId: 'totalKlaviyoPlacedOrderTotalPriceCampaigns',
    services: ['klaviyo'],
    icon: 'klaviyo',
    metricPopupWidget: true,
    providerId: 'klaviyo',
    // metric: 'totalPriceCampaigns',
  },
  klaviyoPlacedOrderTotalPriceCampaignsPercent: {
    id: 'klaviyoPlacedOrderTotalPriceCampaignsPercent',
    title: 'Percent of Revenue Campaigns',
    color: '#c43e13',
    type: 'percent',
    valueToFixed: 0,
    chart: 'chartKlaviyoPlacedOrderTotalPriceCampaigns',
    metricId: 'totalKlaviyoPlacedOrderSalesPercentCampaigns',
    services: ['klaviyo'],
    icon: 'klaviyo',
    providerId: 'klaviyo',
    // metric: 'totalPriceCampaignsPercent',
  },
  klaviyoNewSubscribed: {
    id: 'klaviyoNewSubscribed',
    type: 'decimal',
    title: 'New Subscribed',
    color: '#e2e572',
    chart: 'chartKlaviyoSubscribedToList',
    metricId: 'totalKlaviyoSubscribedToList',
    services: ['klaviyo'],
    icon: 'klaviyo',
    providerId: 'klaviyo',
    // metric: 'newSubscribed',
  },
  klaviyoEmailsClicked: {
    id: 'klaviyoEmailsClicked',
    title: 'Emails Clicked',
    color: '#e2e572',
    type: 'decimal',
    chart: 'chartKlaviyoClickedEmail',
    metricId: 'totalKlaviyoClickedEmail',
    services: ['klaviyo'],
    positiveComparison: -1,
    icon: 'klaviyo',
    providerId: 'klaviyo',
    // metric: 'emailsClicked',
  },
  klaviyoReceivedEmail: {
    id: 'klaviyoReceivedEmail',
    title: 'Emails Received',
    color: '#e2e572',
    type: 'decimal',
    chart: 'chartKlaviyoReceivedEmail',
    metricId: 'totalKlaviyoReceivedEmail',
    services: ['klaviyo'],
    positiveComparison: -1,
    icon: 'klaviyo',
    providerId: 'klaviyo',
    // metric: 'receivedEmail',
  },
  klaviyoSmsClicked: {
    id: 'klaviyoSmsClicked',
    title: 'SMS Clicked',
    color: '#e2e572',
    type: 'decimal',
    chart: 'chartKlaviyoClickedSms',
    metricId: 'totalKlaviyoClickedSms',
    services: ['klaviyo'],
    positiveComparison: -1,
    icon: 'klaviyo',
    providerId: 'klaviyo',
    // metric: 'smsClicked',
  },
  klaviyoCVR: {
    id: 'klaviyoCVR',
    title: 'CVR',
    color: '#e2e572',
    chart: 'chartKlaviyoCVR',
    type: 'decimal',
    metricId: 'klaviyoCVR',
    tip: 'Conversion Rate. Purchase Number / Received Emails',
    services: ['klaviyo'],
    positiveComparison: -1,
    icon: 'klaviyo',
    providerId: 'klaviyo',
    metric: 'conversionRate',
  },
  klaviyoRevenuePerEmail: {
    id: 'klaviyoRevenuePerEmail',
    title: 'Revenue Per Email',
    color: '#e2e572',
    chart: 'chartKlaviyoRevenuePerEmail',
    metricId: 'klaviyoRevenuePerEmail',
    type: 'decimal',
    tip: 'Sales / Received Emails',
    services: ['klaviyo'],
    positiveComparison: -1,
    icon: 'klaviyo',
    providerId: 'klaviyo',
    // metric: 'revenuePerEmail',
  },
  klaviyoNetNewSubscribers: {
    id: 'klaviyoNetNewSubscribers',
    title: 'Net New subscribers',
    type: 'decimal',
    color: '#e2e572',
    chart: 'chartKlaviyoNetNewSubscribers',
    metricId: 'totalKlaviyoNetNewSubscribers',
    services: ['klaviyo'],
    icon: 'klaviyo',
    providerId: 'klaviyo',
    // metric: 'netNewSubscribers',
  },
  klaviyoPlacedOrderSales: {
    id: 'klaviyoPlacedOrderSales',
    title: 'Total Revenue',
    reportTitle: 'klaviyo Total Revenue',
    type: 'currency',
    valueToFixed: 0,
    color: '#de509f',
    metricId: 'klaviyoPlacedOrderSales',
    services: ['klaviyo'],
    icon: 'klaviyo',
    providerId: 'klaviyo',
    // metric: 'placedOrderSales',
  },

  attentivePlacedOrderSales: {
    id: 'attentivePlacedOrderSales',
    title: 'Total Revenue',
    type: 'currency',
    valueToFixed: 0,
    color: '#de509f',
    metricId: 'attentivePlacedOrderSales',
    services: ['ATTENTIVE'],
    icon: 'attentive',
  },
  totalAttentivePlacedOrder: {
    id: 'totalAttentivePlacedOrder',
    title: 'Placed Order',
    type: 'decimal',
    valueToFixed: 0,
    color: '#de509f',
    metricId: 'totalAttentivePlacedOrder',
    services: ['ATTENTIVE'],
    icon: 'attentive',
  },
  attentiveNewSubscribed: {
    id: 'attentiveNewSubscribed',
    title: 'New Subscribed',
    icon: 'attentive',
    type: 'decimal',
    color: '#e2e572',
    chart: 'chartAttentiveNewSubscribed',
    metricId: 'totalAttentiveNewSubscribed',
    services: ['ATTENTIVE'],
    positiveComparison: -1,
  },
  attentiveNetNewsubscribers: {
    id: 'attentiveNetNewsubscribers',
    title: 'Net New subscribers',
    icon: 'attentive',
    type: 'decimal',
    color: '#e2e572',
    chart: 'chartAttentiveNetNewsubscribers',
    metricId: 'totalAttentiveNetNewsubscribers',
    services: ['ATTENTIVE'],
    positiveComparison: -1,
  },
  attentiveUnsubscribed: {
    id: 'attentiveUnsubscribed',
    title: 'Unsubscribed',
    icon: 'attentive',
    type: 'decimal',
    color: '#e2e572',
    chart: 'chartAttentiveUnsubscribed',
    metricId: 'totalAttentiveUnsubscribed',
    services: ['ATTENTIVE'],
    positiveComparison: -1,
  },
  attentiveSalesPercent: {
    id: 'attentiveSalesPercent',
    title: 'Attentive Sales %',
    icon: 'attentive',
    type: 'percent',
    shortTitle: 'Klaviyo Sales',
    chart: 'chartAttentivePlacedOrderSalesPercent',
    color: '#a63099',
    metricId: 'totalAttentivePlacedOrderSalesPercent',
    valueToFixed: 0,
    services: ['ATTENTIVE'],
  },
  attentivePlacedOrderTotalPriceFlows: {
    id: 'attentivePlacedOrderTotalPriceFlows',
    title: 'Revenue Flows',
    icon: 'attentive',
    color: '#79ba51',
    chart: 'chartAttentivePlacedOrderTotalPriceFlows',
    metricId: 'totalAttentivePlacedOrderTotalPriceFlows',
    type: 'currency',
    valueToFixed: 0,
    services: ['ATTENTIVE'],
  },
  attentivePlacedOrderTotalPriceFlowsPercent: {
    id: 'attentivePlacedOrderTotalPriceFlowsPercent',
    title: 'Percent of Revenue Flows',
    icon: 'attentive',
    type: 'percent',
    color: '#071096',
    valueToFixed: 0,
    chart: 'chartAttentivePlacedOrderTotalPriceFlows',
    metricId: 'totalAttentivePlacedOrderSalesPercentFlows',
    services: ['ATTENTIVE'],
  },
  attentivePlacedOrderTotalPriceCampaigns: {
    id: 'attentivePlacedOrderTotalPriceCampaigns',
    title: 'Revenue Campaigns',
    icon: 'attentive',
    color: '#1120f2',
    type: 'currency',
    valueToFixed: 0,
    chart: 'chartAttentivePlacedOrderTotalPriceCampaigns',
    metricId: 'totalAttentivePlacedOrderTotalPriceCampaigns',
    services: ['ATTENTIVE'],
  },
  attentivePlacedOrderTotalPriceCampaignsPercent: {
    id: 'attentivePlacedOrderTotalPriceCampaignsPercent',
    title: 'Percent of Revenue Campaigns',
    icon: 'attentive',
    type: 'percent',
    color: '#c43e13',
    valueToFixed: 0,
    chart: 'chartAttentivePlacedOrderTotalPriceCampaigns',
    metricId: 'totalAttentivePlacedOrderSalesPercentCampaigns',
    services: ['ATTENTIVE'],
  },
  tiktokAds: {
    id: 'tiktokAds',
    title: 'TikTok Ads',
    reportTitle: 'TikTok Ads Spend',
    chart: 'tiktokSpendChart',
    color: '#30a808',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'tiktok_spend',
    services: ['tiktok-ads'],
    icon: 'tiktok',
    providerId: 'tiktok-ads',
    metric: 'spend',
  },
  tiktokRoas: {
    id: 'tiktokRoas',
    title: 'TikTok ROAS',
    shortTitle: 'ROAS',
    chart: 'tiktokRoasChart',
    valueToFixed: 2,
    type: 'decimal',
    color: '#90aa7f',
    metricId: 'tiktok_complete_payment_roas',
    services: ['tiktok-ads'],
    tip: 'Return on Ad Spend',
    icon: 'tiktok',
    providerId: 'tiktok-ads',
    metric: 'roas',
    isSupportCumulative: false,
  },
  tiktokImpressions: {
    id: 'tiktokImpressions',
    title: 'TikTok Impressions',
    shortTitle: 'Impressions',
    chart: 'tiktokImpressionsChart',
    valueToFixed: 0,
    type: 'decimal',
    color: '#a975c1',
    metricId: 'tiktokImpressions',
    services: ['tiktok-ads'],
    icon: 'tiktok',
    providerId: 'tiktok-ads',
    metric: 'impressions',
  },
  tiktokCpm: {
    id: 'tiktokCpm',
    title: 'TikTok CPM',
    shortTitle: 'CPM',
    chart: 'chartTiktokCpm',
    valueToFixed: 0,
    type: 'currency',
    color: '#a69521',
    metricId: 'averageTiktokCpm',
    services: ['tiktok-ads'],
    positiveComparison: -1,
    tip: 'Cost Per 1000 Impressions',
    icon: 'tiktok',
    providerId: 'tiktok-ads',
    metric: 'cpm',
  },
  tiktokCpc: {
    id: 'tiktokCpc',
    title: 'TikTok CPC',
    shortTitle: 'CPC',
    chart: 'chartTiktokCpc',
    valueToFixed: 2,
    color: '#0539d3',
    metricId: 'averageTiktokCpc',
    services: ['tiktok-ads'],
    positiveComparison: -1,
    icon: 'tiktok',
    tip: 'Cost Per Click',
    type: 'decimal',
    providerId: 'tiktok-ads',
    metric: 'cpc',
  },
  tiktokCtr: {
    id: 'tiktokCtr',
    title: 'TikTok CTR',
    shortTitle: 'CTR',
    chart: 'chartTiktokCtr',
    valueToFixed: 2,
    type: 'percent',
    color: '#765b19',
    metricId: 'tiktokCtr',
    services: ['tiktok-ads'],
    icon: 'tiktok',
    providerId: 'tiktok-ads',
    metric: 'ctr',
  },
  tiktokCpa: {
    id: 'tiktokCpa',
    title: 'TikTok CPA',
    shortTitle: 'CPA',
    color: '#1d1a8e',
    type: 'currency',
    metricId: 'tiktokCpa',
    chart: 'tiktokCpaChart',
    services: ['tiktok-ads'],
    positiveComparison: -1,
    tip: 'Cost Per Acquisition',
    icon: 'tiktok',
    providerId: 'tiktok-ads',
    metric: 'cpa',
  },
  tiktokConversionValue: {
    id: 'tiktokConversionValue',
    title: 'TikTok Conversion Value',
    shortTitle: 'Conversion Value',
    color: '#f2d5f4',
    type: 'currency',
    valueToFixed: 0,
    chart: 'tiktokConversionValueChart',
    metricId: 'tiktokConversionValue',
    services: ['tiktok-ads'],
    icon: 'tiktok',
    providerId: 'tiktok-ads',
    metric: 'conversionValue',
  },
  tiktokPurchases: {
    id: 'tiktokPurchases',
    title: 'TikTok Purchases',
    shortTitle: 'Purchases',
    color: '#f2d5f4',
    type: 'decimal',
    valueToFixed: 0,
    chart: 'tiktokPurchasesChart',
    metricId: 'tiktokPurchases',
    services: ['tiktok-ads'],
    icon: 'tiktok',
    providerId: 'tiktok-ads',
    metric: 'purchases',
  },
  uniqueCustomerSales: {
    id: 'uniqueCustomerSales',
    title: 'LTV',
    color: '#4497d9',
    metricId: 'uniqueCustomerLifetimeValue',
    services: ['shopify'],
    valueToFixed: 2,
    type: 'currency',
    tip: 'Lifetime Value. Sales / Unique Customers',
    icon: 'shopify',
    isShowLoadWhenImport: 'shopify',
    providerId: 'shopify',
    metric: 'lifetimeValue', //??
  },
  customerFrequency: {
    id: 'customerFrequency',
    title: 'Frequency',
    color: '#9537de',
    type: 'decimal',
    metricId: 'customerFrequency',
    services: ['shopify'],
    valueToFixed: 2,
    tip: 'The average number of times Unique Customers place a purchase',
    icon: 'tripleWhale',
    isShowLoadWhenImport: 'shopify',
    providerId: 'shopify',
    metric: 'frequency', //??
  },
  ltvCpa: {
    id: 'ltvCpa',
    title: 'LTV/CPA',
    type: 'decimal',
    color: '#264a15',
    metricId: 'ltvCpa',
    services: ['shopify'],
    valueToFixed: 2,
    tip: 'Lifetime Value / Cost Per Acquisition',
    icon: 'tripleWhale',
    isShowLoadWhenImport: 'shopify',
    providerId: 'shopify',
    metric: 'ltvPerCpa', //??
  },
  mer: {
    id: 'mer',
    title: 'MER',
    color: '#c2ec95',
    metricId: 'mer',
    type: 'percent',
    valueToFixed: 0,
    services: ['facebook-ads', 'google-ads', 'snapchat-ads', 'tiktok-ads'],
    tip: 'Marketing Efficiency Ratio. Percentage of Sales spent on Ads. Blended Ad Spend / Order Revenue x 100',
    positiveComparison: -1,
    icon: 'tripleWhale',
    chart: 'merChart',
    additionalMarketplaceBadge: true,
    providerId: 'triple-whale',
    metric: 'marketingEfficiencyRatio',
  },
  totalReturns: {
    id: 'totalReturns',
    title: 'Returns %',
    color: '#f247dd',
    tip: 'Returns / Order Revenue. The percentage of your returns relative to your sales',
    metricId: 'totalReturns',
    type: 'percent',
    valueToFixed: 1,
    services: ['shopify'],
    icon: 'shopify',
    chart: 'totalReturnsChart',
    providerId: 'shopify',
    metric: 'returnsTotal',
  },
  orders: {
    id: 'orders',
    title: 'Orders',
    type: 'decimal',
    color: '#e3ac62',
    tip: 'Number of Orders within the selected timeframe',
    chart: 'chartOrders',
    metricId: 'totalOrders',
    services: ['shopify'],
    icon: 'shopify',
    providerId: 'shopify',
    metric: 'orders',
  },
  shopifyOrdersWithAmount: {
    id: 'shopifyOrdersWithAmount',
    title: 'Orders > $0',
    chart: 'chartOrdersWithAmount',
    color: '#e3ac62',
    tip: 'Shopify Orders excluding $0 Orders',
    type: 'decimal',
    metricId: 'totalOrdersWithAmount',
    services: ['shopify'],
    icon: 'shopify',
    providerId: 'shopify',
    metric: 'ordersWithAmount',
  },
  taxes: {
    id: 'taxes',
    title: 'Taxes',
    color: '#91ca65',
    chart: 'chartNetTaxes',
    tip: 'Amount customers paid in taxes - returned taxes',
    metricId: 'totalNetTaxes',
    services: ['shopify'],
    valueToFixed: 0,
    type: 'currency',
    icon: 'shopify',
    providerId: 'shopify',
    metric: 'taxes',
  },

  grossSales: {
    id: 'grossSales',
    title: 'Gross Sales',
    color: '#91ca65',
    chart: 'chartNewGrossSales',
    tip: 'Product price x quantity (before taxes, shipping, discounts and returns)',
    metricId: 'totalNewGrossSales',
    services: ['shopify'],
    valueToFixed: 0,
    type: 'currency',
    icon: 'shopify',
    providerId: 'shopify',
    metric: 'grossSales',
  },

  newCustomersPercent: {
    id: 'newCustomersPercent',
    title: 'New Customers',
    color: '#cfce47',
    chart: 'chartNewCustomersPercent',
    tip: 'Percentage of orders placed by New Customers',
    metricId: 'newCustomersPercent',
    type: 'percent',
    valueToFixed: 0,
    services: ['shopify'],
    icon: 'shopify',
    providerId: 'shopify',
    metric: 'newCustomersPercent',
  },
  oldCustomersPercent: {
    id: 'oldCustomersPercent',
    title: 'Returning Customers',
    color: '#3675b5',
    chart: 'chartOldCustomersPercent',
    tip: 'Percentage of orders placed by Returning Customers',
    metricId: 'oldCustomersPercent',
    valueToFixed: 0,
    type: 'percent',
    services: ['shopify'],
    icon: 'shopify',
    providerId: 'shopify',
    metric: 'oldCustomersPercent',
  },
  newCustomersOrders: {
    id: 'newCustomersOrders',
    title: 'New Customer Orders',
    color: '#cfce47',
    chart: 'chartNewCustomersOrders',
    tip: 'Number of orders placed by New Customers',
    metricId: 'newCustomersOrders',
    type: 'decimal',
    valueToFixed: 0,
    services: ['shopify'],
    icon: 'shopify',
    providerId: 'shopify',
    metric: 'newCustomerOrders',
  },
  uniqueCustomers: {
    id: 'uniqueCustomers',
    title: 'Unique Customers',
    color: '#dba655',
    type: 'decimal',
    tip: 'Number of Unique Customers within the selected timeframe',
    metricId: 'getUniqueCustomerCount',
    valueToFixed: 0,
    services: ['shopify'],
    icon: 'shopify',
    isShowLoadWhenImport: 'shopify',
    providerId: 'shopify',
    metric: 'uniqueCustomers',
  },
  shipping: {
    id: 'shipping',
    title: 'Shipping',
    color: '#6ebb15',
    metricId: 'totalShippingCosts',
    tip: 'Amount the store paid in shipping costs for fulfilling orders within the select timeframe. Edit these in: Store > Shipping',
    valueToFixed: 0,
    features: [FeatureFlag.EXPENSES_ACCESS_FF],
    type: 'currency',
    chart: 'totalShippingCostsChart',
    services: ['shopify'],
    icon: (stats) => {
      return stats?.activeShippingProvider ?? 'shopify';
    },
    providerId: 'shopify',
    metric: 'shipping',
  },
  discounts: {
    id: 'discounts',
    title: 'Discounts',
    color: '#e3ac62',
    metricId: 'totalDiscounts',
    tip: 'Discount amount including shipping discounts',
    chart: 'totalDiscountsChart',
    valueToFixed: 0,
    type: 'currency',
    services: ['shopify'],
    icon: 'shopify',
    providerId: 'shopify',
    metric: 'discounts',
  },
  googleAnalyticsUsers: {
    id: 'googleAnalyticsUsers',
    title: 'Sessions',
    color: '#19bfd9',
    chart: 'chartGaUsers',
    metricId: 'totalGoogleAnalyticsUsers',
    isShow: (state) => state.isShowGoogleAnalytics,
    valueToFixed: 0,
    type: 'decimal',
    services: ['GOOGLE_ANALYTICS'],
    icon: 'googleAnalytics',
  },
  gorgiasTotalTicketsCreated: {
    id: 'gorgiasTotalTicketsCreated',
    title: 'Tickets Created',
    type: 'decimal',
    color: '#f5c08c',
    chart: 'chartGorgiasTicketsCreated',
    metricId: 'totalGorgiasTicketsCreated',
    valueToFixed: 0,
    services: ['GORGIAS'],
    positiveComparison: -1,
    icon: 'gorgias',
    providerId: 'gorgias',
    // metric: 'totalTicketsCreated',
  },
  gorgiasTotalTicketsReplied: {
    id: 'gorgiasTotalTicketsReplied',
    title: 'Tickets Replied',
    type: 'decimal',
    color: '#12db7c',
    chart: 'chartGorgiasTicketsReplied',
    metricId: 'totalGorgiasTicketsReplied',
    valueToFixed: 0,
    services: ['GORGIAS'],
    icon: 'gorgias',
    providerId: 'gorgias',
    // metric: 'totalTicketsReplied',
  },
  gorgiasAverageResponseTime: {
    id: 'gorgiasAverageResponseTime',
    title: 'Response Time',
    color: '#e092a7',
    chart: 'chartGorgiasResponseTime',
    type: 'decimal',
    metricId: 'averageGorgiasResponseTime',
    isMinutes: true,
    services: ['GORGIAS'],
    positiveComparison: -1,
    icon: 'gorgias',
    providerId: 'gorgias',
    // metric: 'averageResponseTime',
  },
  gorgiasAverageResolutionTime: {
    id: 'gorgiasAverageResolutionTime',
    title: 'Resolution Time',
    color: '#c0fbf5',
    chart: 'chartGorgiasResolutionTime',
    metricId: 'averageGorgiasResolutionTime',
    isMinutes: true,
    services: ['GORGIAS'],
    icon: 'gorgias',
    type: 'decimal',
    // metric: 'averageResolutionTime',
    providerId: 'gorgias',
  },
  totalVariantsSold: {
    id: 'totalVariantsSold',
    title: 'Units Sold',
    type: 'decimal',
    color: '#092129',
    tip: 'The Number Of Individual Items Sold Within Order Count',
    chart: 'chartTotalVariantsSold',
    metricId: 'totalVariantsSold',
    services: ['shopify'],
    icon: 'shopify',
    providerId: 'shopify',
    metric: 'itemsSold',
  },
  blendedAds: {
    id: 'blendedAds',
    title: 'Blended Ad Spend',
    shortTitle: 'Ads',
    chart: 'chartBlendedAds',
    color: '#f03911',
    metricId: 'blendedAds',
    type: 'currency',
    valueToFixed: 0,
    services: blendedServices,
    relatedMetrics: [
      'facebookAds',
      'googleAds',
      'snapchatAds',
      'tiktokAds',
      'pinterestAds',
      'influencerSpend',
      'totalCustomAdSpends',
      'twitterAds',
      'bingAdSpend',
      'mountainSpend',
      'criteoSpend',
      'smsbumpSpend',
    ],
    tip: 'Total Ad Spend. This includes the reported ad spend of each marketing channel connected to Triple Whale, plus any Custom Expenses marked as Ad Spend',
    icon: 'blended',
    additionalMarketplaceBadge: true,
    providerId: 'triple-whale',
    metric: 'blendedSpend',
  },
  roas: {
    id: 'roas',
    title: 'Blended ROAS',
    shortTitle: 'ROAS',
    chart: 'chartRoas',
    hasTarget: true,
    isNotRealTime: true,
    color: '#82E1DA',
    valueToFixed: 2,
    type: 'decimal',
    metricId: 'totalRoas',
    services: blendedServices,
    relatedMetrics: [
      'facebookRoas',
      'googleRoas',
      'tiktokRoas',
      'snapchatRoas',
      'pinterestRoas',
      'twitterRoas',
      'bingRoas',
      'mountainRoas',
      'criteoRoas',
    ],
    tip: 'Blended Return on Ad Spend. Order Revenue / Blended Ads',
    icon: 'blended',
    additionalMarketplaceBadge: true,
    providerId: 'triple-whale',
    metric: 'blendedRoas',
  },
  newCustomersRoas: {
    id: 'newCustomersRoas',
    title: 'New Customer ROAS',
    shortTitle: 'NC-ROAS',
    hasTarget: true,
    color: '#82E1DA',
    type: 'decimal',
    valueToFixed: 2,
    metricId: 'newCustomersRoas',
    services: blendedServices,
    tip: 'New Customer Return on Ad Spend. Sales from New Customers / Blended Ad Spend',
    icon: 'blended',
    chart: 'chartNewCustomerRoas',
    isShowLoadWhenImport: 'shopify',
    providerId: 'triple-whale',
    metric: 'blendedNewCustomerRoas',
  },
  blendedAttributedRoas: {
    id: 'blendedAttributedRoas',
    title: 'Blended Attributed ROAS',
    shortTitle: 'BA-ROAS',
    type: 'decimal',
    hasTarget: true,
    chart: 'chartBlendedAttributedRoas',
    color: '#82E1DA',
    valueToFixed: 2,
    metricId: 'blendedAttributedRoas',
    services: ['facebook-ads', 'google-ads', 'snapchat-ads', 'tiktok-ads'],
    tip: 'Blended-Attributed Return on Ad Spend. Total Blended Conversion Value / Blended Ad Spend',
    icon: 'blended',
    additionalMarketplaceBadge: true,
    providerId: 'triple-whale',
    metric: 'blendedAttributedRoas',
  },
  poas: {
    id: 'poas',
    title: 'Profit on Ad Spend',
    shortTitle: 'POAS',
    hasTarget: true,
    type: 'decimal',
    color: '#82E1DA',
    valueToFixed: 2,
    metricId: 'poas',
    services: blendedServices,
    tip: 'Profit on Ad Spend. Gross Profit/Total Ad Spend',
    icon: 'blended',
    additionalMarketplaceBadge: true,
    providerId: 'triple-whale',
    metric: 'blendedPoas',
  },
  shopifyCpa: {
    id: 'shopifyCpa',
    title: 'Blended CPA',
    chart: 'chartTotalCpa',
    color: '#91d70f',
    valueToFixed: 2,
    type: 'currency',
    metricId: 'totalCpa',
    tip: 'Cost Per Acquisition. Blended Ad Spend / Orders > $0',
    services: blendedServices,
    positiveComparison: -1,
    icon: 'blended',
    additionalMarketplaceBadge: true,
    providerId: 'triple-whale',
    metric: 'blendedCpa', //??
  },
  pinterestAds: {
    id: 'pinterestAds',
    title: 'Pinterest Ads',
    reportTitle: 'Pinterest Ads Spend',
    chart: 'pinterestSpendChart',
    color: '#30a808',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'pinterestSpend',
    services: ['pinterest-ads'],
    icon: 'pinterest',
    providerId: 'pinterest-ads',
    metric: 'spend',
  },
  pinterestRoas: {
    id: 'pinterestRoas',
    title: 'Pinterest ROAS',
    shortTitle: 'ROAS',
    chart: 'pinterestRoasChart',
    type: 'decimal',
    valueToFixed: 2,
    color: '#90aa7f',
    metricId: 'pinterestRoas',
    services: ['pinterest-ads'],
    tip: 'Return on Ad Spend',
    icon: 'pinterest',
    providerId: 'pinterest-ads',
    metric: 'roas',
    isSupportCumulative: false,
  },
  pinterestCpc: {
    id: 'pinterestCpc',
    title: 'Pinterest CPC',
    shortTitle: 'CPC',
    type: 'decimal',
    chart: 'pinterestCpcChart',
    valueToFixed: 2,
    color: '#0539d3',
    metricId: 'pinterestCpc',
    services: ['pinterest-ads'],
    positiveComparison: -1,
    tip: 'Cost Per Click',
    icon: 'pinterest',
    providerId: 'pinterest-ads',
    metric: 'cpc',
  },
  pinterestCpm: {
    id: 'pinterestCpm',
    title: 'Pinterest CPM',
    shortTitle: 'CPM',
    chart: 'pinterestCpmChart',
    valueToFixed: 2,
    type: 'currency',
    color: '#a69521',
    metricId: 'pinterestCpm',
    services: ['pinterest-ads'],
    positiveComparison: -1,
    tip: 'Cost Per 1000 Impressions',
    icon: 'pinterest',
    providerId: 'pinterest-ads',
    metric: 'cpm',
  },
  pinterestConversionValue: {
    id: 'pinterestConversionValue',
    title: 'Pinterest Conversion Value',
    shortTitle: 'Conversion Value',
    color: '#f2d5f4',
    type: 'currency',
    valueToFixed: 0,
    chart: 'pinterestConversionValueChart',
    metricId: 'pinterestConversionValue',
    services: ['pinterest-ads'],
    icon: 'pinterest',
    providerId: 'pinterest-ads',
    metric: 'conversionValue',
  },
  pinterestPurchases: {
    id: 'pinterestPurchases',
    title: 'Pinterest Purchases',
    shortTitle: 'Purchases',
    chart: 'pinterestPurchasesChart',
    valueToFixed: 0,
    color: '#765b19',
    type: 'decimal',
    metricId: 'pinterestPurchases',
    services: ['pinterest-ads'],
    icon: 'pinterest',
    providerId: 'pinterest-ads',
    metric: 'purchases',
  },
  pinterestImpressions: {
    id: 'pinterestImpressions',
    title: 'Pinterest Impressions',
    type: 'decimal',
    shortTitle: 'Impressions',
    chart: 'pinterestImpressionsChart',
    valueToFixed: 0,
    color: '#a975c1',
    metricId: 'pinterestImpressions',
    services: ['pinterest-ads'],
    icon: 'pinterest',
    providerId: 'pinterest-ads',
    metric: 'impressions',
  },
  pinterestCtr: {
    id: 'pinterestCtr',
    title: 'Pinterest CTR',
    shortTitle: 'CTR',
    chart: 'pinterestCtrChart',
    valueToFixed: 2,
    type: 'percent',
    color: '#765b19',
    metricId: 'pinterestCtr',
    services: ['pinterest-ads'],
    icon: 'pinterest',
    providerId: 'pinterest-ads',
    metric: 'ctr',
  },
  benchmarksCPM: {
    id: 'benchmarksCPM',
    title: 'Peer Facebook CPM',
    icon: 'benchmarks',
    type: 'currency',
    valueToFixed: 2,
    color: '#e2e572',
    chart: 'chartBenchmarksCPM',
    metricId: 'totalBenchmarksCPM',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Average Facebook Cost Per 1000 Impressions',
  },
  benchmarksCPC: {
    id: 'benchmarksCPC',
    title: 'Peer Facebook CPC',
    icon: 'benchmarks',
    valueToFixed: 2,
    type: 'currency',
    color: '#e2e572',
    chart: 'chartBenchmarksCPC',
    metricId: 'totalBenchmarksCPC',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Average Facebook Cost Per Click',
  },
  benchmarksCTR: {
    id: 'benchmarksCTR',
    title: 'Peer Facebook CTR',
    icon: 'benchmarks',
    type: 'percent',
    valueToFixed: 2,
    color: '#e2e572',
    chart: 'chartBenchmarksCTR',
    metricId: 'totalBenchmarksCTR',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Average Facebook Click Through Rate',
  },
  benchmarksNCROAS: {
    id: 'benchmarksNCROAS',
    title: 'Peer New Customer Blended ROAS',
    shortTitle: 'Peer NC ROAS',
    icon: 'benchmarks',
    valueToFixed: 2,
    type: 'decimal',
    color: '#e2e572',
    chart: 'chartBenchmarksNCROAS',
    metricId: 'totalBenchmarksNCROAS',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Average New Customers Blended Return On Ad Spend',
  },
  benchmarksNCPA: {
    id: 'benchmarksNCPA',
    title: 'Peer New Customer Blended CPA',
    shortTitle: 'Peer NC CPA',
    icon: 'benchmarks',
    type: 'currency',
    valueToFixed: 2,
    color: '#e2e572',
    chart: 'chartBenchmarksNCPA',
    metricId: 'totalBenchmarksNCPA',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Average New Customers Blended Cost Per Acquisition',
  },
  benchmarksBlendedROAS: {
    id: 'benchmarksBlendedROAS',
    title: 'Peer Blended ROAS',
    shortTitle: 'Peer TW Blended ROAS',
    icon: 'benchmarks',
    type: 'decimal',
    valueToFixed: 2,
    color: '#e2e572',
    chart: 'chartBenchmarksBlendedROAS',
    metricId: 'totalBenchmarksBlendedROAS',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Blended Return on Ad Spend. Order Revenue / Blended Ads',
  },
  benchmarksTotalSpendAvg: {
    id: 'benchmarksTotalSpendAvg',
    title: 'Peer Facebook Spend',
    icon: 'benchmarks',
    type: 'currency',
    valueToFixed: 2,
    color: '#e2e572',
    chart: 'chartBenchmarksTotalSpendAAvg',
    metricId: 'totalBenchmarksTotalSpendAvg',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Average Facebook Spend',
  },
  benchmarksNewCustomersAvg: {
    id: 'benchmarksNewCustomersAvg',
    title: 'Peer Facebook New Customers',
    shortTitle: 'Peer FB New Customers',
    icon: 'benchmarks',
    type: 'decimal',
    color: '#e2e572',
    chart: 'chartBenchmarksFBAdsNewCustomersAvg',
    metricId: 'totalBenchmarksNewCustomersAvg',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Average Facebook Number of New Customers',
  },
  benchmarksSize: {
    id: 'benchmarksSize',
    title: 'Peer Group Size',
    icon: 'benchmarks',
    type: 'decimal',
    color: '#e2e572',
    chart: 'chartBenchmarksSize',
    metricId: 'totalBenchmarksSize',
    services: ['benchmarks'],
    positiveComparison: -1,
  },
  benchmarksOrdersAvg: {
    id: 'benchmarksOrdersAvg',
    title: 'Peer Facebook Number Of Orders',
    shortTitle: 'Peer Facebook # Orders',
    icon: 'benchmarks',
    type: 'decimal',
    color: '#e2e572',
    chart: 'chartBenchmarksOrdersAvg',
    metricId: 'totalBenchmarksOrdersAvg',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Average Facebook Number of Orders',
  },
  benchmarksNewCustomersTotalPriceAvg: {
    id: 'benchmarksNewCustomersTotalPriceAvg',
    title: 'Peer New Customers Conversion Value',
    shortTitle: 'Peer NC CV',
    icon: 'benchmarks',
    type: 'currency',
    valueToFixed: 2,
    color: '#e2e572',
    chart: 'chartBenchmarksNewCustomersTotalPriceAvg',
    metricId: 'totalBenchmarksNewCustomersTotalPriceAvg',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Average New Customers Conversion Value',
  },
  benchmarksBlendedSpendAvg: {
    id: 'benchmarksBlendedSpendAvg',
    title: 'Peer TW Blended Spend',
    icon: 'benchmarks',
    valueToFixed: 2,
    type: 'currency',
    color: '#e2e572',
    chart: 'chartBenchmarksTotalPriceUSDAvg',
    metricId: 'totalBenchmarksBlendedSpendAvg',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Total Ad Spend. This includes the reported ad spend of each marketing channel connected to Triple Whale',
  },
  benchmarksFBAdsSpendAvg: {
    id: 'benchmarksFBAdsSpendAvg',
    title: 'Peer Facebook Ads Spend',
    icon: 'benchmarks',
    valueToFixed: 2,
    type: 'currency',
    color: '#e2e572',
    chart: 'chartBenchmarksFBAdsSpendAvg',
    metricId: 'totalBenchmarksFBAdsSpendAvg',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Average Facebook Spend',
  },
  benchmarksFBAdsImpressionsAvg: {
    id: 'benchmarksFBAdsImpressionsAvg',
    title: 'Peer Facebook Impressions',
    icon: 'benchmarks',
    type: 'decimal',
    color: '#e2e572',
    chart: 'chartBenchmarksFBAdsImpressionsAvg',
    metricId: 'totalBenchmarksFBAdsImpressionsAvg',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Average Facebook Impressions',
  },
  benchmarksFBAdsClicksAvg: {
    id: 'benchmarksFBAdsClicksAvg',
    title: 'Peer Facebook Clicks',
    icon: 'benchmarks',
    type: 'decimal',
    color: '#e2e572',
    chart: 'chartBenchmarksFBAdsClicksAvg',
    metricId: 'totalBenchmarksFBAdsClicksAvg',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Average Facebook Clicks',
  },
  benchmarksFacebookRoas: {
    id: 'benchmarksFacebookRoas',
    title: 'Peer Facebook ROAS',
    icon: 'benchmarks',
    type: 'decimal',
    valueToFixed: 2,
    color: '#e2e572',
    chart: 'chartBenchmarksFacebookRoas',
    metricId: 'benchmarksFacebookRoas',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Average Facebook Return On Ad Spend',
  },
  benchmarksGoogleRoas: {
    id: 'benchmarksGoogleRoas',
    title: 'Peer Google ROAS',
    icon: 'benchmarks',
    type: 'decimal',
    valueToFixed: 2,
    color: '#e2e572',
    chart: 'chartBenchmarksGoogleRoas',
    metricId: 'benchmarksGoogleRoas',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Average Google Return On Ad Spend',
  },
  totalBenchmarksCPCGoogle: {
    id: 'totalBenchmarksCPCGoogle',
    title: 'Peer Google CPC',
    icon: 'benchmarks',
    type: 'currency',
    valueToFixed: 2,
    color: '#e2e572',
    chart: 'chartBenchmarksCPCGoogle',
    metricId: 'totalBenchmarksCPCGoogle',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Average Google Cost Per Click',
  },
  totalBenchmarksCPMGoogle: {
    id: 'totalBenchmarksCPMGoogle',
    title: 'Peer Google CPM',
    icon: 'benchmarks',
    type: 'currency',
    valueToFixed: 2,
    color: '#e2e572',
    chart: 'chartBenchmarksCPMGoogle',
    metricId: 'totalBenchmarksCPMGoogle',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Average Google Cost Per Thousand Impressions',
  },
  totalBenchmarksCTRGoogle: {
    id: 'totalBenchmarksCTRGoogle',
    title: 'Peer Google CTR',
    icon: 'benchmarks',
    type: 'percent',
    valueToFixed: 2,
    color: '#e2e572',
    chart: 'chartBenchmarksCTRGoogle',
    metricId: 'totalBenchmarksCTRGoogle',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Average Google Click Through Rate',
  },
  totalBenchmarksGoogleAdsSpendAvg: {
    id: 'totalBenchmarksGoogleAdsSpendAvg',
    title: 'Peer Google Spend',
    icon: 'benchmarks',
    type: 'currency',
    valueToFixed: 2,
    color: '#e2e572',
    chart: 'chartBenchmarksGoogleAdsSpendAvg',
    metricId: 'totalBenchmarksGoogleAdsSpendAvg',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Ad Spend',
  },
  totalBenchmarksCTRTiktok: {
    id: 'totalBenchmarksCTRTiktok',
    title: 'Peer Tiktok CTR',
    icon: 'benchmarks',
    type: 'percent',
    valueToFixed: 2,
    color: '#e2e572',
    chart: 'chartBenchmarksCTRTiktok',
    metricId: 'totalBenchmarksCTRTiktok',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Click Through Rate. Percentage of people clicking the ad',
  },
  totalBenchmarksCPCTiktok: {
    id: 'totalBenchmarksCPCTiktok',
    title: 'Peer Tiktok CPC',
    icon: 'benchmarks',
    type: 'currency',
    valueToFixed: 2,
    color: '#e2e572',
    chart: 'chartBenchmarksCPCTiktok',
    metricId: 'totalBenchmarksCPCTiktok',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Cost Per Click',
  },
  benchmarksTiktokRoas: {
    id: 'benchmarksTiktokRoas',
    title: 'Peer Tiktok ROAS',
    icon: 'benchmarks',
    type: 'decimal',
    valueToFixed: 2,
    color: '#e2e572',
    chart: 'chartBenchmarksTiktokRoas',
    metricId: 'benchmarksTiktokRoas',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Return on Ad Spend. Order Revenue / Blended Ads',
  },
  totalBenchmarksTiktokAdsSpendAvg: {
    id: 'totalBenchmarksTiktokAdsSpendAvg',
    title: 'Peer Tiktok Spend',
    icon: 'benchmarks',
    type: 'currency',
    valueToFixed: 2,
    color: '#e2e572',
    chart: 'chartBenchmarksTiktokAdsSpendAvg',
    metricId: 'totalBenchmarksTiktokAdsSpendAvg',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Ad Spend',
  },
  totalBenchmarksBlendedCTR: {
    id: 'totalBenchmarksBlendedCTR',
    title: 'Peer TW Blended CTR',
    icon: 'benchmarks',
    type: 'percent',
    valueToFixed: 2,
    color: '#e2e572',
    chart: 'chartBenchmarksBlendedCTR',
    metricId: 'totalBenchmarksBlendedCTR',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Blended Click Through Rate. This includes data of each marketing channel connected to Triple Whale',
  },
  totalBenchmarksBlendedCpc: {
    id: 'totalBenchmarksBlendedCpc',
    title: 'Peer TW Blended CPC',
    icon: 'benchmarks',
    type: 'currency',
    valueToFixed: 2,
    color: '#e2e572',
    chart: 'chartBenchmarksBlendedCpc',
    metricId: 'totalBenchmarksBlendedCpc',
    services: ['benchmarks'],
    positiveComparison: -1,
    tip: 'Blended Cost Per Click. This includes data of each marketing channel connected to Triple Whale',
  },
  totalFacebookEnq: {
    id: 'totalFacebookEnq',
    title: 'From facebook',
    icon: 'facebook',
    type: 'percent',
    valueToFixed: 2,
    color: '#e2e572',
    metricId: 'totalFacebookEnq',
    services: ['enquirelabs'],
    chart: 'totalFacebookEnqChart',
  },
  totalGoogleEnq: {
    id: 'totalGoogleEnq',
    title: 'From Google',
    icon: 'googleAds',
    type: 'percent',
    valueToFixed: 2,
    color: '#e2e572',
    metricId: 'totalGoogleEnq',
    services: ['enquirelabs'],
    chart: 'totalGoogleEnqChart',
  },
  totalSnapchatEnq: {
    id: 'totalSnapchatEnq',
    title: 'From Snapchat',
    icon: 'snapchat',
    type: 'percent',
    valueToFixed: 2,
    color: '#e2e572',
    metricId: 'totalSnapchatEnq',
    services: ['enquirelabs'],
    chart: 'totalSnapchatEnqChart',
  },
  totalTiktokEnq: {
    id: 'totalTiktokEnq',
    title: 'From TikTok',
    icon: 'tiktok',
    type: 'percent',
    valueToFixed: 2,
    color: '#e2e572',
    metricId: 'totalTiktokEnq',
    services: ['enquirelabs'],
    chart: 'totalTiktokEnqChart',
  },
  totalPinterestEnq: {
    id: 'totalPinterestEnq',
    title: 'From Pinterest',
    icon: 'pinterest',
    type: 'percent',
    valueToFixed: 2,
    color: '#e2e572',
    metricId: 'totalPinterestEnq',
    services: ['enquirelabs'],
    chart: 'totalPinterestEnqChart',
  },
  totalInstagramEnq: {
    id: 'totalInstagramEnq',
    title: 'From Instagram',
    icon: 'instagram',
    type: 'percent',
    valueToFixed: 2,
    color: '#e2e572',
    metricId: 'totalInstagramEnq',
    services: ['enquirelabs'],
    chart: 'totalInstagramEnqChart',
  },
  responsesPrecent: {
    services: ['enquirelabs'],
    id: 'responsesPrecent',
    title: '% Responses',
    icon: 'enquirelabs',
    type: 'percent',
    valueToFixed: 2,
    color: '#e2e572',
    metricId: 'responsesPrecent',
    tip: '% responses from total orders',
  },
  totalFacebookKno: {
    id: 'totalFacebookKno',
    title: 'From facebook',
    icon: 'facebook',
    type: 'percent',
    valueToFixed: 2,
    color: '#e2e572',
    metricId: 'totalFacebookKno',
    services: ['kno'],
    chart: 'totalFacebookKnoChart',
  },
  totalGoogleKno: {
    id: 'totalGoogleKno',
    title: 'From Google',
    icon: 'googleAds',
    type: 'percent',
    valueToFixed: 2,
    color: '#e2e572',
    metricId: 'totalGoogleKno',
    services: ['kno'],
    chart: 'totalGoogleKnoChart',
  },
  totalSnapchatKno: {
    id: 'totalSnapchatKno',
    title: 'From Snapchat',
    icon: 'snapchat',
    type: 'percent',
    valueToFixed: 2,
    color: '#e2e572',
    metricId: 'totalSnapchatKno',
    services: ['kno'],
    chart: 'totalSnapchatKnoChart',
  },
  totalTiktokKno: {
    id: 'totalTiktokKno',
    title: 'From TikTok',
    icon: 'tiktok',
    type: 'percent',
    valueToFixed: 2,
    color: '#e2e572',
    metricId: 'totalTiktokKno',
    services: ['kno'],
    chart: 'totalTiktokKnoChart',
  },
  totalPinterestKno: {
    id: 'totalPinterestKno',
    title: 'From Pinterest',
    icon: 'pinterest',
    type: 'percent',
    valueToFixed: 2,
    color: '#e2e572',
    metricId: 'totalPinterestKno',
    services: ['kno'],
    chart: 'totalPinterestKnoChart',
  },
  totalInstagramKno: {
    id: 'totalInstagramKno',
    title: 'From Instagram',
    icon: 'instagram',
    type: 'percent',
    valueToFixed: 2,
    color: '#e2e572',
    metricId: 'totalInstagramKno',
    services: ['kno'],
    chart: 'totalInstagramKnoChart',
  },
  responsesPrecentKno: {
    services: ['kno'],
    id: 'responsesPrecentKno',
    title: '% Responses',
    icon: 'kno',
    type: 'percent',
    valueToFixed: 2,
    color: '#e2e572',
    metricId: 'responsesPrecentKno',
    tip: '% responses from total orders',
  },
  facebookLikes: {
    id: 'facebookLikes',
    title: 'Likes',
    icon: 'facebook',
    type: 'decimal',
    chart: 'chartFacebookLikes',
    color: '#ac26c2',
    valueToFixed: 0,
    metricId: 'facebookLikes',
    services: ['FACEBOOK_SOCIAL'],
    tip: 'total likes for page and posts',
  },
  facebookComments: {
    id: 'facebookComments',
    title: 'Comments',
    icon: 'facebook',
    type: 'decimal',
    chart: 'chartFacebookComments',
    color: '#ac26c2',
    valueToFixed: 0,
    metricId: 'facebookComments',
    services: ['FACEBOOK_SOCIAL'],
    tip: '',
  },
  facebookShares: {
    id: 'facebookShares',
    title: 'Shares',
    icon: 'facebook',
    type: 'decimal',
    chart: 'chartFacebookShares',
    color: '#ac26c2',
    valueToFixed: 0,
    metricId: 'facebookShares',
    services: ['FACEBOOK_SOCIAL'],
    tip: '',
  },
  facebookPosts: {
    id: 'facebookPosts',
    title: 'Posts',
    icon: 'facebook',
    type: 'decimal',
    chart: 'chartFacebookPosts',
    color: '#ac26c2',
    valueToFixed: 0,
    metricId: 'facebookPosts',
    services: ['FACEBOOK_SOCIAL'],
    tip: '',
  },
  facebookFollowers: {
    id: 'facebookFollowers',
    title: 'Followers',
    icon: 'facebook',
    type: 'decimal',
    chart: 'chartFacebookFollowers',
    color: '#ac26c2',
    valueToFixed: 0,
    metricId: 'facebookFollowers',
    services: ['FACEBOOK_SOCIAL'],
    tip: '',
  },
  facebookSocialImpressions: {
    id: 'facebookSocialImpressions',
    title: 'Impressions',
    icon: 'facebook',
    type: 'decimal',
    chart: 'chartFacebookImpressions',
    color: '#ac26c2',
    valueToFixed: 0,
    metricId: 'facebookSocialImpressions',
    services: ['FACEBOOK_SOCIAL'],
    tip: '',
  },
  facebookSocialAvg: {
    id: 'facebookSocialAvg',
    title: 'AVG',
    icon: 'facebook',
    type: 'decimal',
    chart: 'chartFacebookSocialAvg',
    color: '#ac26c2',
    valueToFixed: 0,
    metricId: 'facebookSocialAvg',
    services: ['FACEBOOK_SOCIAL'],
    tip: '',
  },
  facebookReach: {
    id: 'facebookReach',
    title: 'Reach',
    icon: 'facebook',
    type: 'decimal',
    chart: 'chartFacebookReach',
    color: '#ac26c2',
    valueToFixed: 0,
    metricId: 'facebookReach',
    services: ['FACEBOOK_SOCIAL'],
    tip: '',
  },
  facebookProfileView: {
    id: 'facebookProfileView',
    title: 'Profile view',
    icon: 'facebook',
    type: 'decimal',
    chart: 'chartFacebookProfileView',
    color: '#ac26c2',
    valueToFixed: 0,
    metricId: 'facebookProfileView',
    services: ['FACEBOOK_SOCIAL'],
    tip: '',
  },
  facebookWebsiteClicks: {
    id: 'facebookWebsiteClicks',
    title: 'Website Clicks',
    icon: 'facebook',
    type: 'decimal',
    chart: 'chartFacebookWebsiteClicks',
    color: '#ac26c2',
    valueToFixed: 0,
    metricId: 'facebookWebsiteClicks',
    services: ['FACEBOOK_SOCIAL'],
    tip: '',
  },
  instagramLikes: {
    id: 'instagramLikes',
    title: 'Likes',
    icon: 'instagram',
    type: 'decimal',
    chart: 'chartInstagramLikes',
    color: '#ac26c2',
    valueToFixed: 0,
    metricId: 'instagramLikes',
    services: ['FACEBOOK_SOCIAL'],
    tip: '',
  },
  instagramComments: {
    id: 'instagramComments',
    title: 'Comments',
    icon: 'instagram',
    type: 'decimal',
    chart: 'chartInstagramComments',
    color: '#ac26c2',
    valueToFixed: 0,
    metricId: 'instagramComments',
    services: ['FACEBOOK_SOCIAL'],
    tip: '',
  },
  instagramShares: {
    id: 'instagramShares',
    title: 'Shares',
    icon: 'instagram',
    type: 'decimal',
    chart: 'chartInstagramShares',
    color: '#ac26c2',
    valueToFixed: 0,
    metricId: 'instagramShares',
    services: ['FACEBOOK_SOCIAL'],
    tip: '',
  },
  instagramPosts: {
    id: 'instagramPosts',
    title: 'Media posted',
    icon: 'instagram',
    type: 'decimal',
    chart: 'chartInstagramPosts',
    color: '#ac26c2',
    valueToFixed: 0,
    metricId: 'instagramPosts',
    services: ['FACEBOOK_SOCIAL'],
    tip: '',
  },
  instagramFollowers: {
    id: 'instagramFollowers',
    title: 'Followers',
    icon: 'instagram',
    type: 'decimal',
    chart: 'chartInstagramFollowers',
    color: '#ac26c2',
    valueToFixed: 0,
    metricId: 'instagramFollowers',
    services: ['FACEBOOK_SOCIAL'],
    tip: '',
  },
  instagramImpressions: {
    id: 'instagramImpressions',
    title: 'Impressions',
    icon: 'instagram',
    type: 'decimal',
    chart: 'chartInstagramImpressions',
    color: '#ac26c2',
    valueToFixed: 0,
    metricId: 'instagramImpressions',
    services: ['FACEBOOK_SOCIAL'],
    tip: '',
  },
  instagramAvg: {
    id: 'instagramAvg',
    title: 'AVG',
    icon: 'instagram',
    type: 'decimal',
    chart: 'chartInstagramAvg',
    color: '#ac26c2',
    valueToFixed: 0,
    metricId: 'instagramAvg',
    services: ['FACEBOOK_SOCIAL'],
    tip: '',
  },
  instagramAvgImpressionsFollowers: {
    id: 'instagramAvgImpressionsFollowers',
    title: 'AVG',
    icon: 'instagram',
    type: 'decimal',
    chart: 'chartInstagramAvgImpressionsFollowers',
    color: '#ac26c2',
    valueToFixed: 0,
    metricId: 'instagramAvgImpressionsFollowers',
    services: ['FACEBOOK_SOCIAL'],
    tip: '',
  },
  instagramReach: {
    id: 'instagramReach',
    title: 'Reach',
    icon: 'instagram',
    type: 'decimal',
    chart: 'chartInstagramReach',
    color: '#ac26c2',
    valueToFixed: 0,
    metricId: 'instagramReach',
    services: ['FACEBOOK_SOCIAL'],
    tip: '',
  },
  instagramProfileView: {
    id: 'instagramProfileView',
    title: 'Profile view',
    icon: 'instagram',
    type: 'decimal',
    chart: 'chartInstagramProfileView',
    color: '#ac26c2',
    valueToFixed: 0,
    metricId: 'instagramProfileView',
    services: ['FACEBOOK_SOCIAL'],
    tip: '',
  },
  instagramWebsiteClicks: {
    id: 'instagramWebsiteClicks',
    title: 'Website Clicks',
    icon: 'instagram',
    type: 'decimal',
    chart: 'chartInstagramWebsiteClicks',
    color: '#ac26c2',
    valueToFixed: 0,
    metricId: 'instagramWebsiteClicks',
    services: ['FACEBOOK_SOCIAL'],
    tip: '',
  },
  influencerConversionValue: {
    id: 'influencerConversionValue',
    metricId: 'influencerConversionValue',
    title: 'Affluencer Conversion Value',
    shortTitle: 'CV',
    chart: 'influencerConversionValueChart',
    color: '',
    valueToFixed: 0,
    type: 'currency',
    services: ['influencers'],
    tip: 'Conversion Value',
    icon: 'influencers',
  },
  influencerSpend: {
    id: 'influencerSpend',
    metricId: 'influencerSpend',
    title: 'Affluencer Spend',
    shortTitle: '',
    chart: 'influencerSpendChart',
    color: '',
    valueToFixed: 0,
    type: 'currency',
    services: ['influencers'],
    icon: 'influencers',
  },
  influencerRoas: {
    id: 'influencerRoas',
    metricId: 'influencerRoas',
    title: 'Affluencer Roas',
    shortTitle: '',
    chart: 'influencerRoasChart',
    color: '',
    valueToFixed: 2,
    type: 'decimal',
    services: ['influencers'],
    tip: 'Return on Ad Spend',
    icon: 'influencers',
  },
  influencerPurchases: {
    id: 'influencerPurchases',
    metricId: 'influencerPurchases',
    title: 'Affluencer Purchases',
    shortTitle: '',
    chart: 'influencerPurchasesChart',
    color: '',
    valueToFixed: 0,
    type: 'decimal',
    services: ['influencers'],
    icon: 'influencers',
  },
  influencerNcPurchases: {
    id: 'influencerNcPurchases',
    metricId: 'influencerNcPurchases',
    title: 'Affluencer New Customer Purchases',
    shortTitle: 'NC Purchases',
    chart: 'influencerNcPurchasesChart',
    color: '',
    valueToFixed: 0,
    type: 'decimal',
    services: ['influencers'],
    icon: 'influencers',
  },
  influencerNcConversionValue: {
    id: 'influencerNcConversionValue',
    metricId: 'influencerNcConversionValue',
    title: 'Affluencer New Customer Conversion Value',
    shortTitle: 'NC CV',
    chart: 'influencerNcConversionValueChart',
    color: '',
    valueToFixed: 0,
    type: 'currency',
    services: ['influencers'],
    tip: 'New Customer Conversion Value',
    icon: 'influencers',
  },
  totalCustomAdSpends: {
    id: 'totalCustomAdSpends',
    metricId: 'totalCustomAdSpends',
    title: 'Custom Expense Ad Spend',
    chart: 'totalCustomAdSpendsChart',
    color: '',
    valueToFixed: 0,
    type: 'currency',
    services: [],
    icon: 'tripleWhale',
    providerId: 'triple-whale',
    // metric:'customSpend'
  },
  totalCustomNonAdSpends: {
    id: 'totalCustomNonAdSpends',
    metricId: 'totalCustomNonAdSpends',
    title: 'Custom Expenses excl. Ad Spend',
    chart: 'totalCustomNonAdSpendsChart',
    color: '',
    valueToFixed: 0,
    type: 'currency',
    services: [],
    icon: 'tripleWhale',
    providerId: 'triple-whale',
  },
  amazonSales: {
    id: 'amazonSales',
    title: 'Amazon Sales',
    shortTitle: 'Sales',
    chart: 'chartAmazonSales',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalAmazonSales',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'What the customer paid for the order including shipping, taxes, discounts',
    providerId: 'amazon',
    metric: 'sales',
  },
  amazonProductItemPrice: {
    id: 'amazonProductItemPrice',
    title: 'Amazon Product Sales',
    shortTitle: 'Product Sales',
    chart: 'chartAmazonProductItemPrice',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalAmazonProductItemPrice',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'The amount of ordered product sales, calculated by multiplying the price of order items and the number of units sold for the selected time period. This is what Amazon shows in the Sales Dashboard.',
    providerId: 'amazon',
    // metric: 'productSales',
  },
  amazonSalesTaxes: {
    id: 'amazonSalesTaxes',
    title: 'Amazon Taxes',
    shortTitle: 'Taxes',
    chart: 'chartAmazonSalesTaxes',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalAmazonSalesTaxes',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Amount customers paid in taxes. ',
    providerId: 'amazon',
    metric: 'taxes',
  },
  amazonOrders: {
    id: 'amazonOrders',
    shortTitle: 'Orders',
    title: 'Amazon Orders',
    chart: 'chartAmazonOrders',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'decimal',
    metricId: 'totalAmazonOrders',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Number of orders placed',
    providerId: 'amazon',
    metric: 'orders',
  },
  amazonItems: {
    id: 'amazonItems',
    title: 'Amazon Items Sold',
    shortTitle: 'Items Sold',
    chart: 'chartAmazonItems',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'decimal',
    metricId: 'totalAmazonItems',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Number of items sold',
    providerId: 'amazon',
    metric: 'itemsSold',
  },
  amazonFees: {
    id: 'amazonFees',
    title: 'Amazon Estimated Fees',
    chart: 'chartAmazonFees',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalAmazonFees',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Estimated fees based on products purchased. This amount is an estimate and is not final until Amazon reports on actual fees',
    providerId: 'amazon',
    // metric: 'fees',
  },
  amazonSalesAFN: {
    id: 'amazonSalesAFN',
    title: 'FBA Amazon Sales',
    shortTitle: 'FBA Sales',
    chart: 'chartAmazonSalesAFN',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalAmazonSalesAFN',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Gross sales value sold in Amazon fulfillment network. What the customer paid for the order including shipping, taxes, discounts',
    providerId: 'amazon',
    // metric: 'amazonSalesAFN',
  },
  amazonProductItemPriceAFN: {
    id: 'amazonProductItemPriceAFN',
    title: 'FBA Amazon Product Sales',
    shortTitle: 'FBA Product Sales',
    chart: 'chartAmazonProductItemPriceAFN',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalAmazonProductItemPriceAFN',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Ordered product sales in Amazon fulfillment network. This is what Amazon shows in the financial report',
    providerId: 'amazon',
    // metric: 'amazonProductItemPriceAFN',
  },
  amazonSalesTaxesAFN: {
    id: 'amazonSalesTaxesAFN',
    title: 'FBA Amazon Taxes',
    shortTitle: 'FBA Taxes',
    chart: 'chartAmazonSalesTaxesAFN',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalAmazonSalesTaxesAFN',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Amount customers paid in taxes on orders placed in Amazon fulfillment network',
    providerId: 'amazon',
    // metric: 'amazonSalesTaxesAFN',
  },
  amazonOrdersAFN: {
    id: 'amazonOrdersAFN',
    title: 'FBA Amazon Orders',
    shortTitle: 'FBA Orders',
    chart: 'chartAmazonOrdersAFN',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'decimal',
    metricId: 'totalAmazonOrdersAFN',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Number of orders placed in Amazon fulfillment network',
    providerId: 'amazon',
    // metric: 'amazonOrdersAFN',
  },
  amazonItemsAFN: {
    id: 'amazonItemsAFN',
    title: 'FBA Amazon Items Sold',
    shortTitle: 'FBA Items Sold',
    chart: 'chartAmazonItemsAFN',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'decimal',
    metricId: 'totalAmazonItemsAFN',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Number of items sold in Amazon fulfillment network',
    providerId: 'amazon',
    // metric: 'amazonItemsAFN',
  },
  amazonFeesAFN: {
    id: 'amazonFeesAFN',
    title: 'FBA Amazon Estimated Fees',
    chart: 'chartAmazonFeesAFN',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalAmazonFeesAFN',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Estimated fees based on products purchased in Amazon fulfillment network. This amount is an estimate and is not final until Amazon reports on actual fees',
    providerId: 'amazon',
    // metric: 'amazonFeesAFN',
  },
  amazonSalesMFN: {
    id: 'amazonSalesMFN',
    title: 'FBM Amazon Sales',
    shortTitle: 'FBM Sales',
    chart: 'chartAmazonSalesMFN',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalAmazonSalesMFN',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Gross sales value sold in Merchant fulfillment network. What the customer paid for the order including shipping, taxes, discounts',
    providerId: 'amazon',
    // metric: 'amazonSalesMFN',
  },
  amazonProductItemPriceMFN: {
    id: 'amazonProductItemPriceMFN',
    title: 'FBM Amazon Product Sales',
    shortTitle: 'FBM Product Sales',
    chart: 'chartAmazonProductItemPriceMFN',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalAmazonProductItemPriceMFN',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Ordered product sales in Merchant fulfillment network. This is what Amazon shows in the financial report',
    providerId: 'amazon',
    // metric: 'amazonProductItemPriceMFN',
  },
  amazonSalesTaxesMFN: {
    id: 'amazonSalesTaxesMFN',
    title: 'FBM Amazon Taxes',
    shortTitle: 'FBM Taxes',
    chart: 'chartAmazonSalesTaxesMFN',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalAmazonSalesTaxesMFN',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Amount customers paid in taxes on orders placed in Merchant fulfillment network',
    providerId: 'amazon',
    // metric: 'amazonSalesTaxesMFN',
  },
  amazonOrdersMFN: {
    id: 'amazonOrdersMFN',
    title: 'FBM Amazon Orders',
    shortTitle: 'FBM Orders',
    chart: 'chartAmazonOrdersMFN',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'decimal',
    metricId: 'totalAmazonOrdersMFN',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Number of orders placed in Merchant fulfillment network',
    providerId: 'amazon',
    // metric: 'amazonOrdersMFN',
  },
  amazonItemsMFN: {
    id: 'amazonItemsMFN',
    title: 'FBM Amazon Items Sold',
    shortTitle: 'FBM Items Sold',
    chart: 'chartAmazonItemsMFN',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'decimal',
    metricId: 'totalAmazonItemsMFN',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Number of items sold in Merchant fulfillment network',
    providerId: 'amazon',
    // metric: 'amazonItemsMFN',
  },
  amazonFeesMFN: {
    id: 'amazonFeesMFN',
    title: 'FBM Amazon Estimated Fees',
    chart: 'chartAmazonFeesMFN',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalAmazonFeesMFN',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Estimated fees based on products purchased in Merchant fulfillment network. This amount is an estimate and is not final until Amazon reports on actual fees',
    providerId: 'amazon',
    // metric: 'amazonFeesMFN',
  },
  canceledAmazonSales: {
    id: 'canceledAmazonSales',
    title: 'Canceled Sales',
    chart: 'chartCanceledAmazonSales',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalCanceledAmazonSales',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Value of canceled orders',
    providerId: 'amazon',
    // metric: 'canceledAmazonSales',
  },
  canceledAmazonProductItemPrice: {
    id: 'canceledAmazonProductItemPrice',
    title: 'Canceled Amazon Product Sales',
    shortTitle: 'Canceled Product Sales',
    chart: 'chartCanceledAmazonProductItemPrice',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalCanceledAmazonProductItemPrice',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Canceled ordered product sales',
    providerId: 'amazon',
    // metric: 'canceledAmazonProductItemPrice',
  },
  canceledAmazonSalesTaxes: {
    id: 'canceledAmazonSalesTaxes',
    title: 'Canceled Taxes',
    chart: 'chartCanceledAmazonSalesTaxes',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalCanceledAmazonSalesTaxes',
    services: ['amazon'],
    icon: 'amazon',
    providerId: 'amazon',
    // metric: 'canceledAmazonSalesTaxes',
  },
  canceledAmazonOrders: {
    id: 'canceledAmazonOrders',
    title: 'Canceled Orders',
    chart: 'chartCanceledAmazonOrders',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'decimal',
    metricId: 'totalCanceledAmazonOrders',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Number of canceled orders',
    providerId: 'amazon',
    // metric: 'canceledAmazonOrders',
  },
  canceledAmazonItems: {
    id: 'canceledAmazonItems',
    title: 'Canceled Items Sold',
    chart: 'chartCanceledAmazonItems',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'decimal',
    metricId: 'totalCanceledAmazonItems',
    services: ['amazon'],
    icon: 'amazon',
    providerId: 'amazon',
    // metric: 'canceledAmazonItems',
  },
  canceledAmazonFees: {
    id: 'canceledAmazonFees',
    title: 'Canceled Amazon Fees',
    chart: 'chartCanceledAmazonFees',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalCanceledAmazonFees',
    services: ['amazon'],
    icon: 'amazon',
    providerId: 'amazon',
    // metric: 'canceledAmazonFees',
  },
  canceledAmazonSalesAFN: {
    id: 'canceledAmazonSalesAFN',
    title: 'Canceled FBA Sales',
    chart: 'chartCanceledAmazonSalesAFN',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalCanceledAmazonSalesAFN',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Value of canceled orders from Amazon fulfillment network',
    providerId: 'amazon',
    // metric: 'canceledAmazonSalesAFN',
  },
  canceledAmazonProductItemPriceAFN: {
    id: 'canceledAmazonProductItemPriceAFN',
    title: 'Canceled FBA Amazon Product Sales',
    shortTitle: 'Canceled FBA Product Sales',
    chart: 'chartCanceledAmazonProductItemPriceAFN',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalCanceledAmazonProductItemPriceAFN',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Canceled ordered product sales in Amazon fulfillment network',
    providerId: 'amazon',
    // metric: 'canceledAmazonProductItemPriceAFN',
  },
  canceledAmazonSalesTaxesAFN: {
    id: 'canceledAmazonSalesTaxesAFN',
    title: 'Canceled FBA Taxes',
    chart: 'chartCanceledAmazonSalesTaxesAFN',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalCanceledAmazonSalesTaxesAFN',
    services: ['amazon'],
    icon: 'amazon',
    providerId: 'amazon',
    // metric: 'canceledAmazonSalesTaxesAFN',
  },
  canceledAmazonOrdersAFN: {
    id: 'canceledAmazonOrdersAFN',
    title: 'Canceled FBA Orders',
    chart: 'chartCanceledAmazonOrdersAFN',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'decimal',
    metricId: 'totalCanceledAmazonOrdersAFN',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Number of canceled orders from Amazon fulfillment network',
    providerId: 'amazon',
    // metric: 'canceledAmazonOrdersAFN',
  },
  canceledAmazonItemsAFN: {
    id: 'canceledAmazonItemsAFN',
    title: 'Canceled FBA Items Sold',
    chart: 'chartCanceledAmazonItemsAFN',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'decimal',
    metricId: 'totalCanceledAmazonItemsAFN',
    services: ['amazon'],
    icon: 'amazon',
    providerId: 'amazon',
    // metric: 'canceledAmazonItemsAFN',
  },
  canceledAmazonFeesAFN: {
    id: 'canceledAmazonFeesAFN',
    title: 'Canceled FBA Amazon Fees',
    chart: 'chartCanceledAmazonFeesAFN',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalCanceledAmazonFeesAFN',
    services: ['amazon'],
    icon: 'amazon',
    providerId: 'amazon',
    // metric: 'canceledAmazonFeesAFN',
  },
  canceledAmazonSalesMFN: {
    id: 'canceledAmazonSalesMFN',
    shortTitle: 'Canceled FBM Sales',
    title: 'Canceled FBM Amazon Sales',
    chart: 'chartCanceledAmazonSalesMFN',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalCanceledAmazonSalesMFN',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Value of canceled orders from Merchant fulfillment network',
    providerId: 'amazon',
    // metric: 'canceledAmazonSalesMFN',
  },
  canceledAmazonProductItemPriceMFN: {
    id: 'canceledAmazonProductItemPriceMFN',
    title: 'Canceled FBM Amazon Product Sales',
    shortTitle: 'Canceled FBM Product Sales',
    chart: 'chartCanceledAmazonProductItemPriceMFN',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalCanceledAmazonProductItemPriceMFN',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Canceled ordered product sales in Merchant fulfillment network',
    providerId: 'amazon',
    // metric: 'canceledAmazonProductItemPriceMFN',
  },
  canceledAmazonSalesTaxesMFN: {
    id: 'canceledAmazonSalesTaxesMFN',
    shortTitle: 'Canceled FBM Taxes',
    title: 'Canceled FBM Amazon Taxes',
    chart: 'chartCanceledAmazonSalesTaxesMFN',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalCanceledAmazonSalesTaxesMFN',
    services: ['amazon'],
    icon: 'amazon',
    providerId: 'amazon',
    // metric: 'canceledAmazonSalesTaxesMFN',
  },
  canceledAmazonOrdersMFN: {
    id: 'canceledAmazonOrdersMFN',
    shortTitle: 'Canceled FBM Orders',
    title: 'Canceled FBM Amazon Orders',
    chart: 'chartCanceledAmazonOrdersMFN',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'decimal',
    metricId: 'totalCanceledAmazonOrdersMFN',
    services: ['amazon'],
    icon: 'amazon',
    tip: 'Number of canceled orders from Merchant fulfillment network',
    providerId: 'amazon',
    // metric: 'canceledAmazonOrdersMFN',
  },
  canceledAmazonItemsMFN: {
    id: 'canceledAmazonItemsMFN',
    shortTitle: 'Canceled FBM Items Sold',
    title: 'Canceled FBM Amazon Items Sold',
    chart: 'chartCanceledAmazonItemsMFN',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'decimal',
    metricId: 'totalCanceledAmazonItemsMFN',
    services: ['amazon'],
    icon: 'amazon',
    isMinutes: false,
    providerId: 'amazon',
    // metric: 'canceledAmazonItemsMFN',
  },
  canceledAmazonFeesMFN: {
    id: 'canceledAmazonFeesMFN',
    shortTitle: 'Canceled FBM Fees',
    title: 'Canceled FBM Amazon Fees',
    chart: 'chartCanceledAmazonFeesMFN',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'totalCanceledAmazonFeesMFN',
    services: ['amazon'],
    icon: 'amazon',
    providerId: 'amazon',
    // metric: 'canceledAmazonFeesMFN',
  },
  amazonAds: {
    id: 'amazonAds',
    shortTitle: 'Ads',
    title: 'Amazon Ads',
    reportTitle: 'Amazon Ads Spend',
    chart: 'chartAmazonAds',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'amazonAds',
    services: ['amazon'],
    icon: 'amazon',
    isMinutes: false,
    tip: 'Ads = Ad spend',
    providerId: 'amazon',
    metric: 'spend',
  },
  amazonROAS: {
    id: 'amazonROAS',
    shortTitle: 'ROAS',
    title: 'Amazon ROAS',
    color: '#7D4DFF',
    valueToFixed: 2,
    type: 'decimal',
    metricId: 'amazonROAS',
    chart: 'amazonRoasChart',
    services: ['amazon'],
    icon: 'amazon',
    isMinutes: false,
    tip: 'Return On Ad Spend',
    providerId: 'amazon',
    metric: 'roas',
    isSupportCumulative: false,
  },
  amazonCPC: {
    id: 'amazonCPC',
    shortTitle: 'CPC',
    title: 'Amazon CPC',
    color: '#7D4DFF',
    valueToFixed: 2,
    type: 'currency',
    metricId: 'amazonCPC',
    services: ['amazon'],
    icon: 'amazon',
    isMinutes: false,
    chart: 'chartAmazonCPC',
    tip: 'Cost Per Click',
    providerId: 'amazon',
    metric: 'cpc',
  },
  amazonClicks: {
    id: 'amazonClicks',
    shortTitle: 'Clicks',
    title: 'Amazon Clicks',
    chart: 'chartAmazonClicks',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'decimal',
    metricId: 'amazonClicks',
    services: ['amazon'],
    icon: 'amazon',
    isMinutes: false,
    tip: 'Total number of clicks',
    providerId: 'amazon',
    metric: 'clicks',
  },
  amazonPurchases: {
    id: 'amazonPurchases',
    shortTitle: 'Purchases',
    title: 'Amazon Purchases',
    chart: 'chartAmazonPurchases',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'decimal',
    metricId: 'amazonPurchases',
    services: ['amazon'],
    icon: 'amazon',
    isMinutes: false,
    tip: 'Number of Amazon Orders attributed to Amazon advertising campaigns',
    providerId: 'amazon',
    metric: 'purchases',
  },
  amazonTACos: {
    id: 'amazonTACos',
    shortTitle: 'TACoS',
    title: 'Amazon TACoS',
    // chart: 'chartCanceledAmazonItemsMFN',
    color: '#7D4DFF',
    valueToFixed: 2,
    type: 'percent',
    metricId: 'amazonTACos',
    services: ['amazon'],
    icon: 'amazon',
    isMinutes: false,
    tip: 'Total advertising cost of sales: (Amazon Advertising Spend / Amazon Total Revenue) x 100',
    providerId: 'amazon',
    // metric: 'tacos',
  },
  amazonAdsConversionValue: {
    id: 'amazonAdsConversionValue',
    shortTitle: 'Ads Conversion Value',
    title: 'Amazon Conversion Value',
    chart: 'amazonConversionValueChart',
    color: '#7D4DFF',
    valueToFixed: 2,
    type: 'currency',
    metricId: 'amazonAdsConversionValue',
    services: ['amazon'],
    icon: 'amazon',
    isMinutes: false,
    tip: 'Amazon reported revenue attributed from your ads',
    providerId: 'amazon',
    metric: 'conversionValue',
  },

  amazonNetSales: {
    id: 'amazonNetSales',
    shortTitle: 'Net Sales',
    title: 'Amazon Net Sales',
    chart: 'chartAmazonNetSales',
    color: '#7D4DFF',
    valueToFixed: 2,
    type: 'currency',
    metricId: 'amazonNetSales',
    services: ['amazon'],
    icon: 'amazon',
    isMinutes: false,
    tip: 'Gross sales - shipping - taxes + shipping discounts',
    providerId: 'amazon',
    metric: 'netSales',
  },
  amazonNetProfit: {
    id: 'amazonNetProfit',
    shortTitle: 'Net Profit',
    title: 'Amazon Net Profit',
    chart: 'cahrtAmazonNetProfit',
    color: '#7D4DFF',
    valueToFixed: 2,
    type: 'currency',
    metricId: 'amazonNetProfit',
    services: ['amazon'],
    icon: 'amazon',
    isMinutes: false,
    tip: 'Net sales - Expenses (COGS, handling fees, amazon estimated fees, Amazon Ad spend)',
    providerId: 'amazon',
    metric: 'netProfit',
  },
  // 'amazonROAS',
  amazonMER: {
    id: 'amazonMER',
    shortTitle: 'MER',
    title: 'Amazon MER',
    chart: 'amazonMERChart',
    color: '#7D4DFF',
    valueToFixed: 2,
    type: 'percent',
    metricId: 'amazonMER',
    services: ['amazon'],
    icon: 'amazon',
    isMinutes: false,
    tip: 'Percentage of sales spent on ads',
    providerId: 'amazon',
    metric: 'marketingEfficiencyRatio',
  },
  amazonAOV: {
    id: 'amazonAOV',
    shortTitle: 'AOV',
    title: 'Amazon AOV',
    chart: 'amazonAOVChart',
    color: '#7D4DFF',
    valueToFixed: 2,
    type: 'currency',
    metricId: 'amazonAOV',
    services: ['amazon'],
    icon: 'amazon',
    isMinutes: false,
    tip: 'Average Order Value. Total Sales / Number of Orders > $0',
    providerId: 'amazon',
    metric: 'aov',
  },
  amazonCPA: {
    id: 'amazonCPA',
    shortTitle: 'CPA',
    title: 'Amazon CPA',
    chart: 'amazonCPAChart',
    color: '#7D4DFF',
    valueToFixed: 2,
    type: 'currency',
    metricId: 'amazonCPA',
    services: ['amazon'],
    icon: 'amazon',
    isMinutes: false,
    tip: 'Cost Per Acquisition. Ad Spend / Orders > $0',
    providerId: 'amazon',
    metric: 'cpa',
  },
  amazonExpenses: {
    id: 'amazonExpenses',
    shortTitle: 'Expenses',
    title: 'Amazon Expenses',
    chart: 'amazonExpensesChart',
    color: '#7D4DFF',
    valueToFixed: 2,
    type: 'currency',
    metricId: 'amazonExpenses',
    services: ['amazon'],
    icon: 'amazon',
    isMinutes: false,
    tip: 'Amazon estimated fees + COGs + Handling fees + Ad Spend ',
    providerId: 'amazon',
    // metric: 'expenses',
  },
  blendedSales: {
    id: 'blendedSales',
    title: 'Blended Sales',
    chart: 'chartBlendedSales',
    color: '#7D4DFF',
    valueToFixed: 2,
    type: 'currency',
    metricId: 'blendedSales',
    isShow: (state) =>
      state.isAmazonConnectedNA || state.isAmazonConnectedEU || state.isAmazonConnectedFE,
    services: ['amazon'],
    icon: 'tripleWhale',
    isMinutes: false,
    tip: 'Shopify Total Revenue + Amazon Sales',
    providerId: 'amazon',
    // metric: 'blendedSales',
  },
  pixelPurchases: {
    id: 'pixelPurchases',
    title: 'Purchases',
    chart: 'pixelPurchasesChart',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'decimal',
    metricId: 'pixelPurchases',
    services: ['pixel'],
    icon: 'pixel',
    providerId: 'triple-whale',
    metric: 'pixelPurchases',
  },
  pixelUniqueAtc: {
    id: 'pixelUniqueAtc',
    title: 'Unique Add to Carts',
    chart: 'pixelUniqueAtcChart',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'decimal',
    metricId: 'pixelUniqueAtc',
    services: ['pixel'],
    icon: 'pixel',
    providerId: 'triple-whale',
    metric: 'pixelUniqueAtc',
  },
  pixelUniqueSessionsAtc: {
    id: 'pixelUniqueSessionsAtc',
    title: 'Sessions with Add to Carts',
    chart: 'pixelUniqueSessionsAtcChart',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'decimal',
    metricId: 'pixelUniqueSessionsAtc',
    services: ['pixel'],
    icon: 'pixel',
    providerId: 'triple-whale',
    //metric: 'pixelUniqueSessionsAtc',
  },
  pixelVisitors: {
    id: 'pixelVisitors',
    title: 'Sessions',
    chart: 'pixelVisitorsChart',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'decimal',
    metricId: 'pixelVisitors',
    services: ['pixel'],
    icon: 'pixel',
    tip: 'Total number of sessions',
    providerId: 'triple-whale',
    metric: 'pixelVisitors',
  },
  pixelUniqueVisitors: {
    id: 'pixelUniqueVisitors',
    title: 'Users',
    chart: 'pixelUniqueVisitorsChart',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'decimal',
    metricId: 'pixelUniqueVisitors',
    services: ['pixel'],
    icon: 'pixel',
    tip: 'Unique users who visited your site',
    providerId: 'triple-whale',
    metric: 'pixelUniqueVisitors',
  },
  pixelConversionRate: {
    id: 'pixelConversionRate',
    title: 'Conversion Rate',
    chart: 'pixelConversionRateChart',
    color: '#7D4DFF',
    valueToFixed: 2,
    type: 'percent',
    metricId: 'pixelConversionRate',
    services: ['pixel'],
    icon: 'pixel',
    tip: 'Website purchases / Sessions',
    providerId: 'triple-whale',
    metric: 'pixelConversionRate',
  },
  pixelAvgPagesPerSession: {
    id: 'pixelAvgPagesPerSession',
    title: 'Pages per Session',
    chart: 'pixelAvgPagesPerSessionChart',
    color: '#7D4DFF',
    valueToFixed: 2,
    type: 'decimal',
    metricId: 'pixelAvgPagesPerSession',
    services: ['pixel'],
    icon: 'pixel',
    tip: 'Average number of pages viewed per session',
    providerId: 'triple-whale',
    // metric: 'pixelAvgPagesPerSession',
  },
  pixelAvgSessionDuration: {
    id: 'pixelAvgSessionDuration',
    title: 'Session Duration',
    chart: 'pixelAvgSessionDurationChart',
    color: '#7D4DFF',
    valueToFixed: 2,
    type: 'duration',
    metricId: 'pixelAvgSessionDuration',
    services: ['pixel'],
    icon: 'pixel',
    tip: 'Average duration of a session',
    providerId: 'triple-whale',
    // metric: 'pixelAvgSessionDuration',
  },
  pixelBounceRate: {
    id: 'pixelBounceRate',
    title: 'Bounce Rate',
    chart: 'pixelBounceRateChart',
    color: '#7D4DFF',
    valueToFixed: 2,
    type: 'percent',
    metricId: 'pixelBounceRate',
    services: ['pixel'],
    icon: 'pixel',
    tip: 'Percentage of sessions that bounce (leave your site after viewing only one page)',
    providerId: 'triple-whale',
    metric: 'pixelBounceRate',
  },
  pixelNewVisitors: {
    id: 'pixelNewVisitors',
    title: 'New Users',
    chart: 'pixelNewVisitorsChart',
    color: '#7D4DFF',
    valueToFixed: 0,
    type: 'decimal',
    metricId: 'pixelNewVisitors',
    services: ['pixel'],
    icon: 'pixel',
    tip: 'Users who visited your site for the first time',
    providerId: 'triple-whale',
    metric: 'pixelNewVisitors',
  },
  pixelPercentNewVisitors: {
    id: 'pixelPercentNewVisitors',
    title: 'New Users %',
    chart: 'pixelPercentNewVisitorsChart',
    color: '#7D4DFF',
    valueToFixed: 2,
    type: 'percent',
    metricId: 'pixelPercentNewVisitors',
    services: ['pixel'],
    icon: 'pixel',
    tip: 'Percentage of new users (New Users / Users)',
    providerId: 'triple-whale',
    metric: 'pixelNewVisitorPerc',
  },
  pixelPercentAtc: {
    id: 'pixelPercentAtc',
    title: 'Add to Cart %',
    chart: 'pixelPercentAtcChart',
    color: '#7D4DFF',
    valueToFixed: 2,
    type: 'percent',
    metricId: 'pixelPercentAtc',
    services: ['pixel'],
    icon: 'pixel',
    tip: 'Percentage of sessions with add to carts (Add to Carts / Sessions)',
    providerId: 'triple-whale',
    // metric: 'pixelPercentAtc',
  },
  pixelCostPerSession: {
    id: 'pixelCostPerSession',
    title: 'Cost per Session',
    chart: 'pixelCostPerSessionChart',
    color: '#7D4DFF',
    valueToFixed: 2,
    type: 'currency',
    metricId: 'pixelCostPerSession',
    services: ['pixel'],
    icon: 'pixel',
    tip: 'Cost per session (Spend / Sessions)',
    providerId: 'triple-whale',
    // metric: 'pixelCostPerSession',
  },
  pixelCostPerAtc: {
    id: 'pixelCostPerAtc',
    title: 'Cost per Add to Cart',
    chart: 'pixelCostPerAtcChart',
    color: '#7D4DFF',
    valueToFixed: 2,
    type: 'currency',
    metricId: 'pixelCostPerAtc',
    services: ['pixel'],
    icon: 'pixel',
    tip: 'Cost per add to cart (Spend / Add to Carts)',
    providerId: 'triple-whale',
    metric: 'pixelCostPerAtc',
  },
  twitterAds: {
    id: 'twitterAds',
    title: 'Twitter Ads',
    reportTitle: 'Twitter Ads Spend',
    chart: 'twitterSpendChart',
    color: '#30a808',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'twitter_spend',
    services: ['twitter-ads'],
    icon: 'twitter',
    providerId: 'twitter-ads',
    metric: 'spend',
  },
  twitterRoas: {
    id: 'twitterRoas',
    title: 'Twitter ROAS',
    shortTitle: 'ROAS',
    chart: 'twitterRoasChart',
    valueToFixed: 2,
    type: 'decimal',
    color: '#90aa7f',
    metricId: 'twitterRoas',
    services: ['twitter-ads'],
    tip: 'Return on Ad Spend',
    icon: 'twitter',
    providerId: 'twitter-ads',
    metric: 'roas',
    isSupportCumulative: false,
  },
  twitterImpressions: {
    id: 'twitterImpressions',
    title: 'Twitter Impressions',
    shortTitle: 'Impressions',
    chart: 'twitterImpressionsChart',
    valueToFixed: 0,
    type: 'decimal',
    color: '#a975c1',
    metricId: 'twitterImpressions',
    services: ['twitter-ads'],
    icon: 'twitter',
    providerId: 'twitter-ads',
    metric: 'impressions',
  },
  twitterCpm: {
    id: 'twitterCpm',
    title: 'Twitter CPM',
    shortTitle: 'CPM',
    chart: 'twitterCpmChart',
    valueToFixed: 0,
    type: 'currency',
    color: '#a69521',
    metricId: 'twitterCpm',
    services: ['twitter-ads'],
    positiveComparison: -1,
    tip: 'Cost Per 1000 Impressions',
    icon: 'twitter',
    providerId: 'twitter-ads',
    metric: 'cpm',
  },
  twitterCpa: {
    id: 'twitterCpa',
    title: 'Twitter CPA',
    shortTitle: 'CPA',
    color: '#1d1a8e',
    type: 'currency',
    metricId: 'twitterCpa',
    chart: 'twitterCpaChart',
    services: ['twitter-ads'],
    positiveComparison: -1,
    tip: 'Cost Per Acquisition',
    icon: 'twitter',
    providerId: 'twitter-ads',
    metric: 'cpa',
  },
  twitterPurchases: {
    id: 'twitterPurchases',
    title: 'Twitter Purchases',
    shortTitle: 'Purchases',
    color: '#f2d5f4',
    type: 'decimal',
    valueToFixed: 0,
    chart: 'twitterPurchasesChart',
    metricId: 'twitterPurchases',
    services: ['twitter-ads'],
    icon: 'twitter',
    providerId: 'twitter-ads',
    metric: 'purchases',
  },
  twitterConversionValue: {
    id: 'twitterConversionValue',
    title: 'Twitter Conversion Value',
    shortTitle: 'Conversion Value',
    color: '#f2d5f4',
    type: 'currency',
    valueToFixed: 0,
    chart: 'twitterConversionValueChart',
    metricId: 'twitterConversionValue',
    services: ['twitter-ads'],
    icon: 'twitter',
    providerId: 'twitter-ads',
    metric: 'conversionValue',
  },

  twitterEngagements: {
    id: 'twitterEngagements',
    title: 'Twitter Engagements',
    shortTitle: 'Engagements',
    color: '#f2d5f4',
    type: 'decimal',
    valueToFixed: 0,
    chart: 'twitterEngagementsChart',
    metricId: 'twitterEngagements',
    services: ['twitter-ads'],
    icon: 'twitter',
    providerId: 'twitter-ads',
    // metric: 'engagements',
  },

  twitterFollows: {
    id: 'twitterFollows',
    title: 'Twitter Follows',
    shortTitle: 'Follows',
    color: '#f2d5f4',
    type: 'decimal',
    valueToFixed: 0,
    chart: 'twitterFollowsChart',
    metricId: 'twitterFollows',
    services: ['twitter-ads'],
    icon: 'twitter',
    providerId: 'twitter-ads',
    // metric: 'follows',
  },
  twitterClicks: {
    id: 'twitterClicks',
    title: 'Twitter Clicks',
    shortTitle: 'Clicks',
    color: '#7D4DFF',
    type: 'decimal',
    valueToFixed: 0,
    chart: 'twitterClicksChart',
    metricId: 'twitterClicks',
    services: ['twitter-ads'],
    icon: 'twitter',
    providerId: 'twitter-ads',
    metric: 'clicks',
  },
  bingAdSpend: {
    id: 'bingAdSpend',
    title: 'Microsoft Ads Spend',
    shortTitle: 'Spend',
    chart: 'bingAdSpendChart',
    color: '#9999ff',
    valueToFixed: 0,
    type: 'currency',
    metricId: 'bingAdSpend',
    services: ['bing'],
    tip: 'Microsoft Ad Spend',
    icon: 'microsoft',
    providerId: 'bing',
    metric: 'spend',
  },
  bingImpressions: {
    id: 'bingImpressions',
    title: 'Microsoft Ads Impressions',
    shortTitle: 'Impressions',
    chart: 'bingImpressionsChart',
    valueToFixed: 0,
    type: 'decimal',
    color: '#a975c1',
    metricId: 'bingImpressions',
    services: ['bing'],
    icon: 'microsoft',
    providerId: 'bing',
    metric: 'impressions',
  },
  bingClicks: {
    id: 'bingClicks',
    title: 'Microsoft Ads Clicks',
    shortTitle: 'Clicks',
    chart: 'bingClicksChart',
    type: 'decimal',
    color: '#aaffdd',
    metricId: 'bingClicks',
    services: ['bing'],
    icon: 'microsoft',
    providerId: 'bing',
    metric: 'clicks',
  },
  bingRoas: {
    id: 'bingRoas',
    title: 'Microsoft Ads ROAS',
    shortTitle: 'ROAS',
    chart: 'bingRoasChart',
    color: '#3333ff',
    type: 'decimal',
    valueToFixed: 2,
    metricId: 'bingRoas',
    services: ['bing'],
    tip: 'Return on Ad Spend',
    icon: 'microsoft',
    providerId: 'bing',
    metric: 'roas',
    isSupportCumulative: false,
  },
  bingConversions: {
    id: 'bingConversions',
    title: 'Microsoft Ads Conversions',
    shortTitle: 'Conversions',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'bingConversionsChart',
    metricId: 'bingConversions',
    services: ['bing'],
    icon: 'microsoft',
    providerId: 'bing',
    // metric: 'conversions',
  },
  bingConversionValue: {
    id: 'bingConversionValue',
    title: 'Microsoft Ads Conversion Value',
    shortTitle: 'Conversion Value',
    color: '#f2d5f4',
    type: 'currency',
    valueToFixed: 0,
    chart: 'bingConversionValueChart',
    metricId: 'bingConversionValue',
    services: ['bing'],
    icon: 'microsoft',
    providerId: 'bing',
    metric: 'conversionValue',
  },
  bingCtr: {
    id: 'bingCtr',
    title: 'Microsoft Ads CTR',
    shortTitle: 'CTR',
    valueToFixed: 2,
    color: '#aaffdd',
    type: 'decimal',
    chart: 'bingCtrChart',
    metricId: 'bingCtr',
    tip: 'Click Through Rate. Percentage of people clicking the ad',
    services: ['bing'],
    icon: 'microsoft',
    providerId: 'bing',
    metric: 'ctr',
  },
  bingCpm: {
    id: 'bingCpm',
    title: 'Microsoft Ads CPM',
    shortTitle: 'CPM',
    color: '#69af13',
    type: 'currency',
    valueToFixed: 0,
    metricId: 'bingCpm',
    chart: 'bingCpmChart',
    services: ['bing'],
    positiveComparison: -1,
    tip: 'Cost Per 1000 Impressions',
    icon: 'microsoft',
    providerId: 'bing',
    metric: 'cpm',
  },
  bingCpa: {
    id: 'bingCpa',
    title: 'Microsoft Ads CPA',
    shortTitle: 'CPA',
    color: '#01e78f',
    type: 'currency',
    valueToFixed: 1,
    metricId: 'bingCpa',
    chart: 'bingCpaChart',
    services: ['bing'],
    positiveComparison: -1,
    tip: 'Cost Per Acquisition',
    icon: 'microsoft',
    providerId: 'bing',
    metric: 'cpa',
  },

  //recharge
  rechargeSubscription1stOrderSales: {
    id: 'rechargeSubscription1stOrderSales',
    tip: 'Gross sales + Taxes + Shipping - Discounts for Subscription 1st orders',
    title: 'Subscription 1st Order Revenue',
    color: '#aaffdd',
    type: 'currency',
    chart: 'rechargeSubscription1stOrderSalesChart',
    metricId: 'rechargeSubscription1stOrderSales',
    services: ['recharge'],
    icon: 'recharge',
    providerId: 'recharge',
    // metric: 'subscription1stOrderSales',
  },

  rechargeSubscriptionRecurringOrder: {
    id: 'rechargeSubscriptionRecurringOrder',
    tip: 'Gross sales + Taxes + Shipping - Discounts for Subscription recurring orders',
    title: 'Subscription Recurring Order Revenue',
    color: '#aaffdd',
    type: 'currency',
    chart: 'rechargeSubscriptionRecurringOrderChart',
    metricId: 'rechargeSubscriptionRecurringOrder',
    services: ['recharge'],
    icon: 'recharge',
    providerId: 'recharge',
    // metric: 'subscriptionRecurringOrder',
  },

  rechargeTotalSubscriptionSales: {
    id: 'rechargeTotalSubscriptionSales',
    tip: 'Total Gross sales + Taxes + Shipping - Discounts for all subscription orders',
    title: 'Total Subscription Order Revenue',
    color: '#aaffdd',
    type: 'currency',
    chart: 'rechargeTotalSubscriptionSalesChart',
    metricId: 'rechargeTotalSubscriptionSales',
    services: ['recharge'],
    icon: 'recharge',
    providerId: 'recharge',
    // metric: 'totalSubscriptionSales',
  },

  rechargeSubscriptionSalesPercentage: {
    id: 'rechargeSubscriptionSalesPercentage',
    tip: '% of total order revenue (Shopify) from subscriptions',
    title: '% Subscription Order Revenue',
    color: '#aaffdd',
    type: 'percent',
    chart: 'rechargeSubscriptionSalesPercentageChart',
    metricId: 'rechargeSubscriptionSalesPercentage',
    services: ['recharge'],
    icon: 'recharge',
    providerId: 'recharge',
    // metric: 'subscriptionSalesPercentage',
  },

  rechargeTotalNewSubscriptions: {
    id: 'rechargeTotalNewSubscriptions',
    tip: 'New subscriptions created by any customers in this period',
    title: 'Total New Subscriptions',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'rechargeTotalNewSubscriptionsChart',
    metricId: 'rechargeTotalNewSubscriptions',
    services: ['recharge'],
    icon: 'recharge',
    providerId: 'recharge',
    // metric: 'totalNewSubscriptions',
  },

  rechargeTotalCancelledSubscriptions: {
    id: 'rechargeTotalCancelledSubscriptions',
    tip: 'Subscriptions cancelled by any customers in this period',
    title: 'Total Cancelled Subscriptions',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'rechargeTotalCancelledSubscriptionsChart',
    metricId: 'rechargeTotalCancelledSubscriptions',
    services: ['recharge'],
    positiveComparison: -1,
    icon: 'recharge',
    providerId: 'recharge',
    // metric: 'totalCancelledSubscriptions',
  },

  rechargeTotalChurnedSubscribers: {
    id: 'rechargeTotalChurnedSubscribers',
    tip: 'Total number of subscribers who have cancelled in this period',
    title: 'Total Churned Subscribers',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'rechargeTotalChurnedSubscribersChart',
    metricId: 'rechargeTotalChurnedSubscribers',
    services: ['recharge'],
    positiveComparison: -1,
    icon: 'recharge',
    providerId: 'recharge',
    // metric: 'totalChurnedSubscribers',
  },

  rechargeTotalActiveSubscriptions: {
    id: 'rechargeTotalActiveSubscriptions',
    tip: 'Total subscriptions active in this period',
    title: 'Total Active Subscriptions',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'rechargeTotalActiveSubscriptionsChart',
    metricId: 'rechargeTotalActiveSubscriptions',
    services: ['recharge'],
    icon: 'recharge',
    showOnlyForToday: true,
    providerId: 'recharge',
    isCumulativeMetric: true,
    isChartStartsWithMinValue: true,
    // metric: 'totalActiveSubscriptions',
  },

  rechargeTotalActiveSubscribers: {
    id: 'rechargeTotalActiveSubscribers',
    tip: 'Total number of subscribers with active subscription as of the last day in this period',
    title: 'Total Active Subscribers',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'rechargeTotalActiveSubscribersChart',
    metricId: 'rechargeTotalActiveSubscribers',
    services: ['recharge'],
    icon: 'recharge',
    showOnlyForToday: true,
    providerId: 'recharge',
    isCumulativeMetric: true,
    isChartStartsWithMinValue: true,
    // metric: 'totalActiveSubscribers',
  },

  rechargeAverageActiveDays: {
    id: 'rechargeAverageActiveDays',
    tip: 'The average length of days that a subscription is active for',
    title: 'Average active days - active subscriptions',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'rechargeAverageActiveDaysChart',
    metricId: 'rechargeAverageActiveDays',
    services: ['recharge'],
    icon: 'recharge',
    providerId: 'recharge',
    // metric: 'averageActiveDays',
  },

  rechargeAverageSubscriptionsPerCustomer: {
    id: 'rechargeAverageSubscriptionsPerCustomer',
    tip: 'The average number of active subscriptions per customer',
    title: 'Average subscriptions per customer',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'rechargeAverageSubscriptionsPerCustomerChart',
    metricId: 'rechargeAverageSubscriptionsPerCustomer',
    services: ['recharge'],
    icon: 'recharge',
    providerId: 'recharge',
    // metric: 'averageSubscriptionsPerCustomer',
  },

  rechargeReactivatedSubscribers: {
    id: 'rechargeReactivatedSubscribers',
    tip: '# of customers who had an active subscription, churned at some point and have re-activated in the specified time range',
    title: 'Reactivated Customers',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'rechargeReactivatedSubscribersChart',
    metricId: 'rechargeReactivatedSubscribers',
    services: ['recharge'],
    icon: 'recharge',
    providerId: 'recharge',
    // metric: 'reactivatedSubscribers',
  },

  //stripe subscriptions

  stripeSubscriptionUpgradeCount: {
    id: 'stripeSubscriptionUpgradeCount',
    tip: '# of subscriptions that have upgraded in the specified time range',
    title: 'Upgrade Subscriptions',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'stripeSubscriptionUpgradeCountChart',
    metricId: 'stripeSubscriptionUpgradeCount',
    services: ['stripe'],
    icon: 'stripe',
    providerId: 'stripe',
    // metric: 'upgradeCount',
  },

  stripeSubscriptionUpgradeAmount: {
    id: 'stripeSubscriptionUpgradeAmount',
    tip: 'Amount of subscriptions that have upgraded in the specified time range',
    title: 'Upgraded Subscriptions Amount',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'stripeSubscriptionUpgradeAmountChart',
    metricId: 'stripeSubscriptionUpgradeAmount',
    services: ['stripe'],
    icon: 'stripe',
    providerId: 'stripe',
    // metric: 'upgradeAmount',
  },

  stripeSubscriptionDowngradeCount: {
    id: 'stripeSubscriptionDowngradeCount',
    tip: '# of subscriptions that have downgraded in the specified time range',
    title: 'Downgrade Subscriptions',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'stripeSubscriptionDowngradeCountChart',
    metricId: 'stripeSubscriptionDowngradeCount',
    services: ['stripe'],
    icon: 'stripe',
    providerId: 'stripe',
    // metric: 'downgradeCount',
  },

  stripeSubscriptionDowngradeAmount: {
    id: 'stripeSubscriptionDowngradeAmount',
    tip: 'Amount of subscriptions that have downgraded in the specified time range',
    title: 'Downgrade Subscription Amount',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'stripeSubscriptionDowngradeAmountChart',
    metricId: 'stripeSubscriptionDowngradeAmount',
    services: ['stripe'],
    icon: 'stripe',
    providerId: 'stripe',
    // metric: 'downgradeAmount',
  },

  stripeSubscriptionDeletedCount: {
    id: 'stripeSubscriptionDeletedCount',
    tip: '# of subscriptions that have deleted in the specified time range',
    title: 'Deleted Subscriptions',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'stripeSubscriptionDeletedCountChart',
    metricId: 'stripeSubscriptionDeletedCount',
    services: ['stripe'],
    icon: 'stripe',
    providerId: 'stripe',
    // metric: 'deletedCount',
  },

  stripeSubscriptionDeletedAmount: {
    id: 'stripeSubscriptionDeletedAmount',
    tip: 'Amount of subscriptions that have deleted in the specified time range',
    title: 'Deleted Subscriptions Amount',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'stripeSubscriptionDeletedAmountChart',
    metricId: 'stripeSubscriptionDeletedAmount',
    services: ['stripe'],
    icon: 'stripe',
    providerId: 'stripe',
    // metric: 'deletedAmount',
  },
  //MNTN

  mountainSpend: {
    id: 'mountainSpend',
    tip: 'Total amount Spent',
    title: 'Spend',
    color: '#aaffdd',
    type: 'currency',
    chart: 'mountainSpendChart',
    metricId: 'mountainSpend',
    services: ['mountain'],
    icon: 'mountain',
    providerId: 'mountain',
    metric: 'spend',
  },

  mountainRoas: {
    id: 'mountainRoas',
    tip: 'Return on ad spend. Calculated by: Order Value ÷ Total Spend',
    title: 'ROAS',
    color: '#aaffdd',
    type: 'decimal',
    valueToFixed: 2,
    chart: 'mountainRoasChart',
    metricId: 'mountainRoas',
    services: ['mountain'],
    icon: 'mountain',
    providerId: 'mountain',
    metric: 'roas',
  },
  mountainImpressions: {
    id: 'mountainImpressions',
    tip: 'Number of ad impressions served',
    title: 'Impressions',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'mountainImpressionsChart',
    metricId: 'mountainImpressions',
    services: ['mountain'],
    icon: 'mountain',
    providerId: 'mountain',
    metric: 'impressions',
  },
  mountainConversions: {
    id: 'mountainConversions',
    tip: 'Number of conversions that followed a verified visit',
    title: 'Conversions',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'mountainConversionsChart',
    metricId: 'mountainConversions',
    services: ['mountain'],
    icon: 'mountain',
    providerId: 'mountain',
    // metric: 'conversions',
  },
  mountainConversionRate: {
    id: 'mountainConversionRate',
    tip: 'Percentage of verified visits that resulted in a conversion',
    title: 'Conversion Rate',
    color: '#aaffdd',
    type: 'percent',
    valueToFixed: 2,
    chart: 'mountainConversionRateChart',
    metricId: 'mountainConversionRate',
    services: ['mountain'],
    icon: 'mountain',
    providerId: 'mountain',
    metric: 'conversionRate',
  },
  mountainConversionValue: {
    id: 'mountainConversionValue',
    tip: 'Total conversion value from MNTN',
    title: 'Conversion Value',
    color: '#aaffdd',
    type: 'currency',
    valueToFixed: 2,
    chart: 'mountainConversionValueChart',
    metricId: 'mountainConversionValue',
    services: ['mountain'],
    icon: 'mountain',
    providerId: 'mountain',
    metric: 'conversionValue',
  },
  mountainAverageOrderValue: {
    id: 'mountainAverageOrderValue',
    tip: 'Average order value. Calculated by: MNTN Total Order Value ÷ MNTN Total Conversions',
    title: 'AOV',
    color: '#aaffdd',
    type: 'currency',
    valueToFixed: 2,
    chart: 'mountainAverageOrderValueChart',
    metricId: 'mountainAverageOrderValue',
    services: ['mountain'],
    icon: 'mountain',
    providerId: 'mountain',
    metric: 'aov',
  },
  mountainCostPerAcquisition: {
    id: 'mountainCostPerAcquisition',
    tip: 'Cost per acquisition. Calculated by: Total Spend ÷ Total Conversions',
    title: 'CPA',
    color: '#aaffdd',
    valueToFixed: 2,
    type: 'currency',
    chart: 'mountainCostPerAcquisitionChart',
    metricId: 'mountainCostPerAcquisition',
    services: ['mountain'],
    icon: 'mountain',
    providerId: 'mountain',
    metric: 'cpa',
  },
  mountainCostPerVisit: {
    id: 'mountainCostPerVisit',
    tip: 'Cost per visit. Calculated by: Total Spend ÷ Total Visits',
    title: 'CPV',
    color: '#aaffdd',
    valueToFixed: 2,
    type: 'currency',
    chart: 'mountainCostPerVisitChart',
    metricId: 'mountainCostPerVisit',
    services: ['mountain'],
    icon: 'mountain',
    providerId: 'mountain',
    // metric: 'costPerVisit',
  },
  //criteo

  criteoSpend: {
    id: 'criteoSpend',
    tip: 'Total amount spent',
    title: 'Spend',
    color: '#aaffdd',
    type: 'currency',
    chart: 'criteoSpendChart',
    metricId: 'criteoSpend',
    services: ['criteo'],
    icon: 'criteo',
    providerId: 'criteo',
    metric: 'spend',
  },

  criteoRoas: {
    id: 'criteoRoas',
    tip: 'Return on ad spend. Calculated by: Revenue Generated ÷ Total Spend',
    title: 'ROAS',
    color: '#aaffdd',
    type: 'decimal',
    valueToFixed: 2,
    chart: 'criteoRoasChart',
    metricId: 'criteoRoas',
    services: ['criteo'],
    icon: 'criteo',
    providerId: 'criteo',
    metric: 'roas',
  },
  criteoDisplays: {
    id: 'criteoDisplays',
    tip: 'The number of ad impressions served on publishers via Criteo',
    title: 'Displays',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'criteoDisplaysChart',
    metricId: 'criteoDisplays',
    services: ['criteo'],
    icon: 'criteo',
    providerId: 'criteo',
    // metric: 'displays',
  },
  criteoConversions: {
    id: 'criteoConversions',
    tip: 'Number of conversions that followed a verified visit',
    title: 'Conversions',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'criteoConversionsChart',
    metricId: 'criteoConversions',
    services: ['criteo'],
    icon: 'criteo',
    providerId: 'criteo',
    // metric: 'conversions',
  },
  criteoConversionRate: {
    id: 'criteoConversionRate',
    tip: 'Percentage of verified visits that resulted in a conversion',
    title: 'Conversion Rate',
    color: '#aaffdd',
    type: 'percent',
    valueToFixed: 2,
    chart: 'criteoConversionRateChart',
    metricId: 'criteoConversionRate',
    services: ['criteo'],
    icon: 'criteo',
    providerId: 'criteo',
    metric: 'conversionRate',
  },
  criteoConversionValue: {
    id: 'criteoConversionValue',
    tip: 'Total conversion value from Criteo',
    title: 'Conversion Value',
    color: '#aaffdd',
    type: 'currency',
    valueToFixed: 2,
    chart: 'criteoConversionValueChart',
    metricId: 'criteoConversionValue',
    services: ['criteo'],
    icon: 'criteo',
    providerId: 'criteo',
    metric: 'conversionValue',
  },
  criteoClicks: {
    id: 'criteoClicks',
    tip: 'The number of clicks driven by Criteo ads',
    title: 'Clicks',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'criteoClicksChart',
    metricId: 'criteoClicks',
    services: ['criteo'],
    icon: 'criteo',
    providerId: 'criteo',
    metric: 'clicks',
  },
  criteoVisits: {
    id: 'criteoVisits',
    tip: 'The number of users on the target website or app for which at least one event occurred within the hour following a click',
    title: 'Visits',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'criteoVisitsChart',
    metricId: 'criteoVisits',
    services: ['criteo'],
    icon: 'criteo',
    providerId: 'criteo',
    // metric: 'visits',
  },
  criteoCostPerVisit: {
    id: 'criteoCostPerVisit',
    tip: 'Cost per visit',
    title: 'CPV',
    color: '#aaffdd',
    valueToFixed: 2,
    type: 'currency',
    chart: 'criteoCostPerVisitChart',
    metricId: 'criteoCostPerVisit',
    services: ['criteo'],
    icon: 'criteo',
    providerId: 'criteo',
    // metric: 'costPerVisit',
  },
  criteoCostPerAcquisition: {
    id: 'criteoCostPerAcquisition',
    tip: 'Cost per acquisition',
    title: 'CPA',
    color: '#aaffdd',
    valueToFixed: 2,
    type: 'currency',
    chart: 'criteoCostPerAcquisitionChart',
    metricId: 'criteoCostPerAcquisition',
    services: ['criteo'],
    icon: 'criteo',
    providerId: 'criteo',
    metric: 'cpa',
  },
  criteoAverageOrderValue: {
    id: 'criteoAverageOrderValue',
    tip: 'Average order value',
    title: 'AOV',
    color: '#aaffdd',
    type: 'currency',
    valueToFixed: 2,
    chart: 'criteoAverageOrderValueChart',
    metricId: 'criteoAverageOrderValue',
    services: ['criteo'],
    icon: 'criteo',
    providerId: 'criteo',
    metric: 'aov',
  },
  pacingTotalRevenue: {
    id: 'pacingTotalRevenue',
    title: 'Total Revenue',
    color: '#aaffdd',
    type: 'string',
    metricId: 'pacing',
    services: ['pacing'],
    icon: () => {},
    isShow: () => true,
  },
  pacingReturningCustomersRevenue: {
    id: 'pacingReturningCustomersRevenue',
    title: 'Returning Customer Revenue',
    color: '#aaffdd',
    type: 'string',
    metricId: 'pacing',
    services: ['pacing'],
    icon: () => {},
    isShow: () => true,
  },
  pacingNewCustomersRevenue: {
    id: 'pacingNewCustomersRevenue',
    title: 'New Customer Revenue',
    color: '#aaffdd',
    type: 'string',
    metricId: 'pacing',
    services: ['pacing'],
    icon: () => {},
    isShow: () => true,
  },
  forwardViewTotalRevenue: {
    id: 'forwardViewTotalRevenue',
    title: 'Total Revenue',
    color: '#aaffdd',
    type: 'currency',
    metricId: 'forwardViewTotalRevenue',
    services: ['forwardView'],
    icon: () => {},
    isShow: () => true,
  },
  forwardViewProductOrdersCount: {
    id: 'forwardViewProductOrdersCount',
    title: 'Orders',
    color: '#aaffdd',
    type: 'decimal',
    valueToFixed: 0,
    metricId: 'forwardViewProductOrdersCount',
    services: ['forwardView'],
    icon: () => {},
    isShow: () => true,
  },
  forwardViewNcCustomerCntAttribution: {
    id: 'forwardViewNcCustomerCntAttribution',
    title: 'New Customers',
    color: '#aaffdd',
    type: 'decimal',
    valueToFixed: 0,
    metricId: 'forwardViewNcCustomerCntAttribution',
    services: ['forwardView'],
    icon: () => {},
    isShow: () => true,
  },
  // pacingTotalNetProfit: {
  //   id: 'pacingTotalNetProfit',
  //   title: 'Total Net Profit',
  //   color: '#aaffdd',
  //   type: 'string',
  //   metricId: 'pacing',
  //   services: ['pacing'],
  //   icon: () => {},
  //   isShow: () => true,
  // },
  pacingBlendedAdSpend: {
    id: 'pacingBlendedAdSpend',
    title: 'Blended Ad Spend',
    color: '#aaffdd',
    type: 'string',
    metricId: 'pacing',
    services: ['pacing'],
    icon: () => {},
    isShow: () => true,
  },
  pacingFacebookAdsConversionValue: {
    id: 'pacingFacebookAdsConversionValue',
    title: 'Facebook Ads Conversion Value',
    color: '#aaffdd',
    type: 'string',
    metricId: 'pacing',
    services: ['pacing'],
    icon: () => {},
    isShow: () => true,
  },
  pacingGoogleAdsConversionValue: {
    id: 'pacingGoogleAdsConversionValue',
    title: 'Google Ads Conversion Value',
    color: '#aaffdd',
    type: 'string',
    metricId: 'pacing',
    services: ['pacing'],
    icon: () => {},
    isShow: () => true,
  },
  pacingTiktokAdsConversionValue: {
    id: 'pacingTiktokAdsConversionValue',
    title: 'Tiktok Ads Conversion Value',
    color: '#aaffdd',
    type: 'string',
    metricId: 'pacing',
    services: ['pacing'],
    icon: () => {},
    isShow: () => true,
  },
  pacingSnapchatAdsConversionValue: {
    id: 'pacingSnapchatAdsConversionValue',
    title: 'Snapchat Ads Conversion Value',
    color: '#aaffdd',
    type: 'string',
    metricId: 'pacing',
    services: ['pacing'],
    icon: () => {},
    isShow: () => true,
  },
  pacingPinterestAdsConversionValue: {
    id: 'pacingPinterestAdsConversionValue',
    title: 'Pinterest Ads Conversion Value',
    color: '#aaffdd',
    type: 'string',
    metricId: 'pacing',
    services: ['pacing'],
    icon: () => {},
    isShow: () => true,
  },

  // Shipstation.
  shipstationCost: {
    id: 'shipstationCost',
    tip: 'Total cost of shipping',
    title: 'Shipping Cost',
    color: '#aaffdd',
    type: 'currency',
    valueToFixed: 2,
    chart: 'shipstationCostChart',
    metricId: 'shipstationCost',
    services: ['shipstation'],
    icon: 'shipstation',
    providerId: 'shipstation',
    metric: 'spend',
  },

  shipstationShipments: {
    id: 'shipstationShipments',
    tip: 'Total number of shipments',
    title: 'Shipments',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'shipstationShipmentsChart',
    metricId: 'shipstationShipments',
    services: ['shipstation'],
    icon: 'shipstation',
    providerId: 'shipstation',
    metric: 'shipping',
  },

  shipstationOrders: {
    id: 'shipstationOrders',
    tip: 'Total number of orders',
    title: 'Orders',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'shipstationOrdersChart',
    metricId: 'shipstationOrders',
    services: ['shipstation'],
    icon: 'shipstation',
    providerId: 'shipstation',
    metric: 'orders',
  },

  shipstationOrdersShipped: {
    id: 'shipstationOrdersShipped',
    tip: 'Total number of orders shipped',
    title: 'Orders Shipped',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'shipstationOrdersShippedChart',
    metricId: 'shipstationOrdersShipped',
    services: ['shipstation'],
    icon: 'shipstation',
    providerId: 'shipstation',
    metric: 'orders',
  },

  shipstationOrdersUnshipped: {
    id: 'shipstationOrdersUnshipped',
    tip: 'Total number of orders unshipped',
    title: 'Orders Unshipped',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'shipstationOrdersUnshippedChart',
    metricId: 'shipstationOrdersUnshipped',
    services: ['shipstation'],
    icon: 'shipstation',
    providerId: 'shipstation',
    metric: 'orders',
  },

  shipstationAvgCostPerShipment: {
    id: 'shipstationAvgCostPerShipment',
    tip: 'Average cost per shipment',
    title: 'Avg Cost Per Shipment',
    color: '#aaffdd',
    type: 'currency',
    valueToFixed: 2,
    chart: 'shipstationAvgCostPerShipmentChart',
    metricId: 'shipstationAvgCostPerShipment',
    services: ['shipstation'],
    icon: 'shipstation',
    providerId: 'shipstation',
    metric: 'shipping',
  },

  shipstationEstimation: {
    id: 'shipstationEstimation',
    tip: "The estimated cost for all orders placed in the chosen timeframe, which don't have a shipping label created yet. The estimation is based on the manual costs entered in the cost settings page.",
    title: 'Unshipped Orders Estimated Cost',
    color: '#aaffdd',
    type: 'currency',
    valueToFixed: 2,
    chart: 'shipstationEstimationChart',
    metricId: 'shipstationEstimation',
    services: ['shipstation'],
    icon: 'tripleWhale',
    providerId: 'shipstation',
    metric: 'shipping',
  },

  //smsbump
  smsbumpSpend: {
    id: 'smsbumpSpend',
    tip: 'Amount spent on Yotpo SMS',
    title: 'Spend',
    color: '#aaffdd',
    type: 'currency',
    chart: 'smsbumpSpendChart',
    metricId: 'smsbumpSpend',
    services: ['smsbump'],
    icon: 'smsbump',
    providerId: 'smsbump',
  },

  smsbumpRevenue: {
    id: 'smsbumpRevenue',
    tip: 'Total revenue generated',
    title: 'Total Revenue',
    color: '#aaffdd',
    type: 'currency',
    chart: 'smsbumpRevenueChart',
    metricId: 'smsbumpRevenue',
    services: ['smsbump'],
    icon: 'smsbump',
    providerId: 'smsbump',
  },

  smsbumpCampaignRevenue: {
    id: 'smsbumpCampaignRevenue',
    tip: 'Total revenue generated from campaigns',
    title: 'Campaign Revenue',
    color: '#aaffdd',
    type: 'currency',
    chart: 'smsbumpCampaignRevenueChart',
    metricId: 'smsbumpCampaignRevenue',
    services: ['smsbump'],
    icon: 'smsbump',
    providerId: 'smsbump',
  },

  smsbumpFlowRevenue: {
    id: 'smsbumpFlowRevenue',
    tip: 'Total revenue generated from flows',
    title: 'Flow Revenue',
    color: '#aaffdd',
    type: 'currency',
    chart: 'smsbumpFlowRevenueChart',
    metricId: 'smsbumpFlowRevenue',
    services: ['smsbump'],
    icon: 'smsbump',
    providerId: 'smsbump',
  },

  smsbumpCtr: {
    id: 'smsbumpCtr',
    tip: 'Click through ratio. Calculated by: Delivered/Clicked',
    title: 'CTR',
    color: '#aaffdd',
    type: 'percent',
    valueToFixed: 2,
    chart: 'smsbumpCtrChart',
    metricId: 'smsbumpCtr',
    services: ['smsbump'],
    icon: 'smsbump',
    providerId: 'smsbump',
  },

  smsbumpRoas: {
    id: 'smsbumpRoas',
    tip: 'Return on ad spend. Calculated by: Revenue Generated/Total Spend',
    title: 'ROAS',
    color: '#aaffdd',
    type: 'decimal',
    valueToFixed: 2,
    chart: 'smsbumpRoasChart',
    metricId: 'smsbumpRoas',
    services: ['smsbump'],
    icon: 'smsbump',
    providerId: 'smsbump',
  },

  smsbumpRoi: {
    id: 'smsbumpRoi',
    tip: 'Return on investment. Calculated by: (Revenue Generated - Total Spend)/Total Spend',
    title: 'ROI',
    color: '#aaffdd',
    type: 'decimal',
    valueToFixed: 2,
    chart: 'smsbumpRoiChart',
    metricId: 'smsbumpRoi',
    services: ['smsbump'],
    icon: 'smsbump',
    providerId: 'smsbump',
  },

  smsbumpConversions: {
    id: 'smsbumpConversions',
    tip: 'Number of conversions that followed a verified visit',
    title: 'Conversions',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'smsbumpConversionsChart',
    metricId: 'smsbumpConversions',
    services: ['smsbump'],
    icon: 'smsbump',
    providerId: 'smsbump',
  },

  smsbumpSent: {
    id: 'smsbumpSent',
    tip: 'Total number of messages sent',
    title: 'Sent',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'smsbumpSentChart',
    metricId: 'smsbumpSent',
    services: ['smsbump'],
    icon: 'smsbump',
    providerId: 'smsbump',
  },

  smsbumpDelivered: {
    id: 'smsbumpDelivered',
    tip: 'Total number of messages delivered',
    title: 'Delivered',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'smsbumpDeliveredChart',
    metricId: 'smsbumpDelivered',
    services: ['smsbump'],
    icon: 'smsbump',
    providerId: 'smsbump',
  },

  smsbumpClicks: {
    id: 'smsbumpClicks',
    tip: 'Total number of clicks',
    title: 'Clicks',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'smsbumpClicksChart',
    metricId: 'smsbumpClicks',
    services: ['smsbump'],
    icon: 'smsbump',
    providerId: 'smsbump',
  },

  smsbumpUnsubscribed: {
    id: 'smsbumpUnsubscribed',
    tip: 'Total number of unsubscribed',
    title: 'Unsubscribed',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'smsbumpUnsubscribedChart',
    metricId: 'smsbumpUnsubscribed',
    services: ['smsbump'],
    icon: 'smsbump',
    providerId: 'smsbump',
  },

  smsbumpAov: {
    id: 'smsbumpAov',
    tip: 'Average order value. Calculated by: Revenue Generated ÷ Total Conversions',
    title: 'AOV',
    color: '#aaffdd',
    type: 'currency',
    valueToFixed: 2,
    chart: 'smsbumpAovChart',
    metricId: 'smsbumpAov',
    services: ['smsbump'],
    icon: 'smsbump',
    providerId: 'smsbump',
  },

  // Shipbob.
  shipbobOrders: {
    id: 'shipbobOrders',
    tip: 'Total number of orders',
    title: 'Orders',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'shipbobOrdersChart',
    metricId: 'shipbobOrders',
    services: ['shipbob'],
    icon: 'shipbob',
    providerId: 'shipbob',
    metric: 'orders',
  },

  shipbobOrdersFulfilled: {
    id: 'shipbobOrdersFulfilled',
    tip: 'Total number of fulfilled orders',
    title: 'Orders fulfilled',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'shipbobOrdersFulfilledChart',
    metricId: 'shipbobOrdersFulfilled',
    services: ['shipbob'],
    icon: 'shipbob',
    providerId: 'shipbob',
    metric: 'orders',
  },

  shipbobPercentOfOrdersFulfilledOnTime: {
    id: 'shipbobPercentOfOrdersFulfilledOnTime',
    tip: 'Percent of orders fulfilled on time',
    title: 'Orders fulfilled on time',
    color: '#aaffdd',
    type: 'percent',
    valueToFixed: 2,
    chart: 'shipbobPercentOfOrdersFulfilledOnTimeChart',
    metricId: 'shipbobPercentOfOrdersFulfilledOnTime',
    services: ['shipbob'],
    icon: 'shipbob',
    providerId: 'shipbob',
    metric: 'orders',
  },

  shipbobFulfillmentCost: {
    id: 'shipbobFulfillmentCost',
    tip: 'Total cost of orders fulfillments',
    title: 'Fulfillments Cost',
    color: '#aaffdd',
    type: 'currency',
    valueToFixed: 2,
    chart: 'shipbobFulfillmentCostChart',
    metricId: 'shipbobFulfillmentCost',
    services: ['shipbob'],
    icon: 'shipbob',
    providerId: 'shipbob',
    metric: 'spend',
  },

  shipbobAvgFulfillmentCost: {
    id: 'shipbobAvgFulfillmentCost',
    tip: 'Average cost per shipment',
    title: 'Avg Cost Per Fulfillment',
    color: '#aaffdd',
    type: 'currency',
    valueToFixed: 2,
    chart: 'shipbobAvgFulfillmentCostChart',
    metricId: 'shipbobAvgFulfillmentCost',
    services: ['shipbob'],
    icon: 'shipbob',
    providerId: 'shipbob',
    metric: 'shipping',
  },

  shipbobEstimation: {
    id: 'shipbobEstimation',
    tip: "The estimated cost for all orders placed in the chosen timeframe, which don't have a shipping label created yet. The estimation is based on the manual costs entered in the cost settings page.",
    title: 'Unfulfilled Orders Estimated Cost',
    color: '#aaffdd',
    type: 'currency',
    valueToFixed: 2,
    chart: 'shipbobEstimationChart',
    metricId: 'shipbobEstimation',
    services: ['shipbob'],
    icon: 'tripleWhale',
    providerId: 'shipbob',
    metric: 'shipping',
  },

  //postscript
  postscriptRevenue: {
    id: 'postscriptRevenue',
    tip: 'Total revenue generated',
    title: 'Total Revenue',
    color: '#aaffdd',
    type: 'currency',
    chart: 'postscriptRevenueChart',
    metricId: 'postscriptRevenue',
    services: ['postscript'],
    icon: 'postscript',
    providerId: 'postscript',
  },

  postscriptSent: {
    id: 'postscriptSent',
    tip: 'Total number of messages sent',
    title: 'Sent',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'postscriptSentChart',
    metricId: 'postscriptSent',
    services: ['postscript'],
    icon: 'postscript',
    providerId: 'postscript',
  },

  postscriptSubscribed: {
    id: 'postscriptSubscribed',
    tip: 'Total number of subscribed',
    title: 'Subscribed',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'postscriptSubscribedChart',
    metricId: 'postscriptSubscribed',
    services: ['postscript'],
    icon: 'postscript',
    providerId: 'postscript',
  },

  postscriptUnsubscribed: {
    id: 'postscriptUnsubscribed',
    tip: 'Total number of unsubscribed',
    title: 'Unsubscribed',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'postscriptUnsubscribedChart',
    metricId: 'postscriptUnsubscribed',
    services: ['postscript'],
    icon: 'postscript',
    providerId: 'postscript',
  },

  postscriptConversions: {
    id: 'postscriptConversions',
    tip: 'Number of conversions that followed a verified visit or click',
    title: 'Conversions',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'postscriptConversionsChart',
    metricId: 'postscriptConversions',
    services: ['postscript'],
    icon: 'postscript',
    providerId: 'postscript',
  },

  postscriptDelivered: {
    id: 'postscriptDelivered',
    tip: 'Total number of messages delivered',
    title: 'Delivered',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'postscriptDeliveredChart',
    metricId: 'postscriptDelivered',
    services: ['postscript'],
    icon: 'postscript',
    providerId: 'postscript',
  },

  postscriptAov: {
    id: 'postscriptAov',
    tip: 'Average order value. Calculated by: Revenue Generated/Total Conversions',
    title: 'AOV',
    color: '#aaffdd',
    type: 'currency',
    valueToFixed: 2,
    chart: 'postscriptAovChart',
    metricId: 'postscriptAov',
    services: ['postscript'],
    icon: 'postscript',
    providerId: 'postscript',
  },

  postscriptCtr: {
    id: 'postscriptCtr',
    tip: 'Click through ratio. Calculated by: Delivered/Clicked',
    title: 'CTR',
    color: '#aaffdd',
    type: 'percent',
    valueToFixed: 2,
    chart: 'postscriptCtrChart',
    metricId: 'postscriptCtr',
    services: ['postscript'],
    icon: 'postscript',
    providerId: 'postscript',
  },

  postscriptClicks: {
    id: 'postscriptClicks',
    tip: 'Total number of clicks',
    title: 'Clicks',
    color: '#aaffdd',
    type: 'decimal',
    chart: 'postscriptClicksChart',
    metricId: 'postscriptClicks',
    services: ['postscript'],
    icon: 'postscript',
    providerId: 'postscript',
  },
};
